<template>
    <div>
        <div>
            <div class="actions-tab in-tab">
                <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <div class="btn-download">
                            <div>
                              <span class="left">
                                  <i class="icon icon-download"></i> {{setText('download')}}
                              </span>
                                <i class="icon icon-keyboard"></i>
                            </div>
                        </div>
                    </template>
                    <template v-if="filteredApps.length">
                        <b-dropdown-item
                            v-for="app in filteredApps"
                            :key="app.id + '_' + app.code"
                            class="text-left"
                            @click="downloadApplication(app.id)"
                        >
                            {{ appText(app) }}
                        </b-dropdown-item>
                    </template>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && ((['005.002.007', '005.002.003', '005.002.002'].includes(accessLevel.modules) && ['abp', 'uf', ''].includes(accessLevel.position)) || (['005.002.001'].includes(accessLevel.modules) && ['ipf'].includes(activeTab)) && ['abp', 'uf', ''].includes(accessLevel.position))" @click="downloadFile('SVI_IPF_PO')">{{setText('svi_ipf_obl')}}</b-dropdown-item>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && ((['005.002.007', '005.002.003', '005.002.002'].includes(accessLevel.modules) && ['abp', 'uf', ''].includes(accessLevel.position)) || (['005.002.001'].includes(accessLevel.modules) && ['ipf'].includes(activeTab)) && ['abp', 'uf', ''].includes(accessLevel.position))" @click="downloadFile('SVI_IPF_PP')">{{setText('svi_ipf_pay')}}</b-dropdown-item>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevel.modules === '005.002.002' && activeTab === 'uf'" @click="downloadFile('SVI_SPF_PO')">{{setText('svi_spf_obl')}}</b-dropdown-item>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevel.modules === '005.002.002' && activeTab === 'uf'" @click="downloadFile('SVI_SPF_PP')">{{setText('svi_spf_pay')}}</b-dropdown-item>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevel.modules === '005.002.002' && activeTab === 'uf'" @click="downloadReferenceExpenses()">{{setText('svi_spf_reference')}}</b-dropdown-item>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && accessLevel.modules === '005.002.008' && !activeTab" @click="downloadFile('SVI_SP_PB')">{{setText('svi_spp')}}</b-dropdown-item>
                    <b-dropdown-item class="text-left" v-if="selectedAlteration && ['005.002.003', '005.002.007'].includes(accessLevel.modules) && ['abp', 'ipf'].includes(activeTab)"  @click="downloadReport()">{{setText('downloads.blocking_report')}}</b-dropdown-item>
                </b-dropdown>
                <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <div class="btn-download">
                            <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                                <i class="icon icon-keyboard"></i>
                            </div>
                        </div>
                    </template>
                    <b-dropdown-text>
                        <div class="info-button"  v-if="[1, 2, 3].includes(tabIndex)">
                            <a href="https://youtu.be/YiJp81fFftI" target="_blank"><span>{{setText('video_instructions.project')}}<i
                                class="icon icon-video"></i></span></a>
                        </div>
                    </b-dropdown-text>
                </b-dropdown>

            </div>
            <div class="filter-container">
                <div class="left-content">
                    <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                        <template #button-content>
                            <span class="lc"><i class="icon icon-filter"></i>{{ setText('filter') }}</span><span class="rc"><i
                            class="icon icon-keyboard"></i></span>
                        </template>
                        <div>
                            <div class="top-content">
                                <span>{{ setText('filter_params') }}</span>
                                <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                            </div>
                            <!---------------------Дата------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('date')">
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="currDate"
                                        format = "DD/MM/YYYY"
                                        type="date"
                                        disabled
                                        style="width: 400px !important; max-width: unset !important;"
                                    />
                                </b-form-group>
                            </div>
                            <!---------------------ГУ------------------------->
                            <div class="filter-block" v-if="currentAlteration.gu">
                                <b-form-group :label="setText('ga')">
                                    <multiselect
                                        v-model="currGu"
                                        label="localText"
                                        :options="guBase"
                                        ref="filterGu"
                                        disabled
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!---------------------Вид заявки------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('request_type')">
                                    <multiselect
                                        v-model="selectedAlteration"
                                        :options="listAlteration"
                                        label="name"
                                        disabled
                                        ref="refAlteration"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------Подведомственные-------------------->
                            <div class="filter-block" v-if="this.currentAlteration.level === 'abp' && [261].includes(this.currentAlteration.abp)">
                                <b-form-group :label="setText('subordinate')">
                                    <multiselect
                                        v-model="abp261gu"
                                        :options="departGU"
                                        label="localText"
                                        @input="sortData"
                                        ref="refDepartGU"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!---------------------Остатки------------------------->
                            <div class="filter-block" v-if="tabIndex !== 5">
                                <b-form-group :label="setText('remains')">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="ost" @change="arrChange()" switch/>
                                    </div>
                                </b-form-group>
                            </div>
                            <!-----------------Остатки (доходы)--------------------->
                            <div class="filter-block" v-if="tabIndex === 5">
                                <b-form-group :label="setText('remains')">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="ostIncome" @change="ostIncomeChange()" switch/>
                                    </div>
                                </b-form-group>
                            </div>
                            <!-------------------Остатки42------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('data_source_420')">
                                    <b-form-radio-group
                                        ref="bcDS420"
                                        :id="'radio-group-3_' + tabCode"
                                        v-model="ds420"
                                        :options="ds420_list"
                                        :name="'radio-options_3_' + tabCode"
                                        @change="dsChange"
                                    >
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                            <!------------------Разрез данных--------------------->
                            <div class="filter-block" v-if="['requestABP', 'referenceABP', 'reference_expenses'].includes(tabCode)">
                                <b-form-group :label="setText('data_slice')" ref="refWithGu">
                                    <b-form-radio-group
                                        :id="'radio-group-withGu-' + tabCode"
                                        v-model="withGu"
                                        :options="withGu_list"
                                        :name="'radio-options-withGu-' + tabCode"
                                    >
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
                <div class="filter-actions">
                    <template>
                        <b-button variant="secondary" @click="onBack">{{setText('back')}}</b-button>
                        <b-button variant="success" v-if="(![2].includes(accessLevel.access_level)) || (monthArr.length > 0 && (roleIncludes('uf_edit') || roleIncludes('gu_edit')))" :disabled="!accessLevel.editAccess" @click="onSave">{{setText('save')}}</b-button>
                        <b-button v-if="operationCode.length > 0" v-show="agrEnabled"
                                  variant="success"
                                  :disabled="(!accessLevel.editAccess || parentStatus) && hasActiveStep79 && hasStatus79"
                                  @click="flcActions">{{setText('actions')}}</b-button>
                    </template>
                </div>
            </div>
        </div>
        <!--  хлебные крошки   -->
        <div class="filter-breadcrumb">
            <span class="item-breadcrumb" v-if="currDate" @click="openFilterByRef('dateRef')">
                {{ refDate }}
            </span>
            <span class="item-breadcrumb" v-if="currGu" @click="openFilterByRef('filterGu')">
                {{ currGu.localText.toString() }}
            </span>
            <span class="item-breadcrumb" v-if="selectedAlteration" @click="openFilterByRef('refAlteration')">
                {{ setText('request_type') }} - {{ selectedAlteration.name }}
            </span>
            <span class="item-breadcrumb" v-if="abp261gu && abp261gu.code !== 0" @click="openFilterByRef('refDepartGU')">
                {{ setText('subordinate') }} - {{ abp261gu.code }}
            </span>
            <span class="item-breadcrumb" v-if="['requestABP', 'referenceABP', 'reference_expenses'].includes(tabCode) && withGu !== null" @click="openFilterByRef('refWithGu')">
                                          {{ setText('data_slice') }} - {{ withGu ? setText('by_gu') : setText('by_abp') }}
            </span>

        </div>
        <!--  Tab-ы обязательства\платежи   -->
        <div v-if="reqType">
            <div>
                <b-tabs class="tabs-in-tabs">
                    <b-tab>
                        <template #title>
                            <button class="icon-btn" @click="toggleShowObligation">
                                <i class="icon icon-keyboard icon-rotate-270" v-if="showObligation"></i>
                                <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                            </button>
                            <span class="ml-2">
                                {{ setText('obligation') }}
                            </span>
                            <div  style="display: flex; gap: 10px; position: absolute; z-index: 1; top: 15px; right: 21px;">
                                <a v-if="monthArr.length > 0 || newRequest" class="badge badge-primary" @click="addItem()"> {{ setText('add') }}</a>
                                <a v-if="monthArr.length > 0 || newRequest" class="badge badge-primary" @click="duplicatedData(0)"> {{ setText('duplicate_pay') }}</a>
                                <a v-if="monthArr.length > 0 || newRequest" class="badge badge-primary" @click="importSpf(1)"> {{ setText('import_obl') }}</a>
                                <a v-if="!(monthArr.length > 0 || newRequest) && tabIndex === 1 && historyTransfersButton" class="badge badge-primary" @click="importTransfers(1)"> {{ setText('import_obl_tr') }}</a>
                            </div>
                        </template>
                        <div class="top-table-line"></div>
                        <c-spf-tree-table v-if="showObligation" :table-data="formObligation" :editedMonths="monthArr" @chgData ="chgDataObl" :accessLevel="accessLevel" :uSumVisible="uSumVisible" :tableType="tableType" :flc2="flc2" :flc4="flc4" @agrBtn="agrBtn" @flcControls="flcControls" :createdMonths="createdMonths" @addItem="addItemTr" :withGU="withGu" :reasonVisible="reasonVisible" :reasonEditable="reasonEditable" :reasonGroups="reasonGroups" :reasonPlanType="1" @editReason="openReasonModal" @viewReason="openReasonViewModal"/>
                    </b-tab>
                </b-tabs>
            </div>
            <div>
                <b-tabs class="tabs-in-tabs">
                    <b-tab>
                        <template #title align="left">
                            <button class="icon-btn" @click="toggleShowPayment">
                                <i class="icon icon-keyboard icon-rotate-270" v-if="showPayment"></i>
                                <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                            </button>
                            <span class="ml-2">
                            {{ setText('payments') }}
                        </span>
                            <div  style="display: flex; gap: 10px; position: absolute; z-index: 1; top: 15px; right: 21px;">
                                <a v-if="monthArr.length > 0 || newRequest" class="badge badge-primary" @click="duplicatedData(1)"> {{ setText('duplicate_obl') }}</a>
                                <a v-if="monthArr.length > 0 || newRequest" class="badge badge-primary" @click="importSpf(2)"> {{ setText('import_pay') }}  </a>
                                <a v-if="!(monthArr.length > 0 || newRequest) && tabIndex === 1 && historyTransfersButton" class="badge badge-primary" @click="importTransfers(2)"> {{ setText('import_pay_tr') }}</a>
                            </div>
                        </template>
                        <div class="top-table-line"></div>
                        <c-spf-tree-table v-if="showPayment" :table-data="formPayment" :editedMonths="monthArr" @chgData ="chgDataPay" :accessLevel="accessLevel" :uSumVisible="uSumVisible" :tableType="tableType" :flc2="flc2" :flc4="flc4" @agrBtn="agrBtn" @flcControls="flcControls" :createdMonths="createdMonths" @addItem="addItemTr" :withGU="withGu" :reasonVisible="reasonVisible" :reasonEditable="reasonEditable" :reasonGroups="reasonGroups" :reasonPlanType="2" @editReason="openReasonModal" @viewReason="openReasonViewModal"/>
                    </b-tab>
                </b-tabs>
            </div>
            <c-spf-add-modal :show="showAddItemModal" :dataTable="formObligation" :abpProp="currAbp" :requestDate="currentAlteration.create_date" @shown="showAddItemModal = false" @addItemClk="addedItems"/>
            <spf-import-from-file-modal
                :cur-abp="currAbp"
                :cur-gu="currGu"
                :cur-year="currYear"
                :cur-region="currRegion"
                :cur-month="currMonth"
                @shown="showImportFileModal = false"
                :show="showImportFileModal"
                @importTableObligations="importObligations"
                @importTablePayments="importPayments"
                @dataUpload="dataUpload"
                :table-type="importTypeTable"
                :request-id="currentAlteration.id"
                :request-types="requestTypes"
            ></spf-import-from-file-modal>
            <!-- заявка АБП - добавление/редактирование (EAK-1557), справка (расходы) - режим просмотра (EAK-808) -->
            <c-reason-modal
                v-if="reasonAvailable || referenceReasonAvailable"
                ref="refReasonModal"
                :requestId="currentAlteration.id"
                :region="currentAlteration.region || (currRegion && currRegion.code)"
                :year="currYear"
                :abp="currentAlteration.abp"
                @changed="loadReasons"
            />
        </div>
        <div v-else>
            <div v-if="(monthArr.length > 0 || newRequest) && roleIncludes('uf_edit')" style="display: flex; gap: 10px; position: absolute; z-index: 1; top: 15px; right: 21px;">
                <a class="badge badge-primary" style="text-transform: uppercase; border-radius: 6px;" @click="addItemIncome()"> {{ setText('add') }} </a>
            </div>
            <!--        компонент по поступлениям       -->
            <c-inc-tree-table :table-data="formIncome" :editedMonths="monthArr" @chgData="chgDataIncome" :accessLevel="accessLevel" :createdMonths="createdMonths" :flc6="flc6" :ost="ostIncome" @agrBtn="agrBtn" @flcControls="flcControls"/>
            <c-inc-add-modal :show="showIncomAddItemModal" :dataTable="formIncome" :param="incParam" @shown="showIncomAddItemModal = false" @addItemClk="addedIncomeItems"/>
        </div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
        <c-budg-agr-modal ref="refAgrModal" :agrBtnLst="agrBtnLst" @agrClk="agrClick"></c-budg-agr-modal>
        <c-budg-agr-hist-modal ref="refHistModal"></c-budg-agr-hist-modal>
        <c-alteration-select-modal
            :show="showSelectModal"
            :isMSU="isUserMSU"
            :currentAlteration="currentAlteration"
            :caller-tab="tabCode"
            :requestTypeOptions="requestTypeOptions"
            @shown="showSelectModal = $event"
        />
        <b-modal
            v-model="closingMessageModal"
            @hide="handleCloseSecondModal"
            centered
            hide-header
            hide-footer
            size="lg"
        >
            <div class="flc-modal">
                <div class="flc-modal__title" style="font-size: 24px;">{{ setText('confirm') }}</div>
                <div></div><hr>
                <div style="color: red; font-size: 16px;"><strong>{{ setText('errors.flc') }}</strong></div><br/>
                <div v-for="(error, index) in arrFlc.slice(0, 4)" :key="index">
                    <p :style="{ color: getErrorColor(error), fontSize: '16px' }">{{ error.textErr }}</p>
                </div>
                <div style="color: red; font-size: 16px;"><strong>{{ setText('flc.agreement') }}</strong></div>
                <hr>
                <div class="d-flex justify-content-end">
                    <b-button class="mt-3" variant="secondary" @click="handleCloseSecondModal"
                    >{{ setText('canc') }}</b-button
                    >
                    <b-button class="mt-3" variant="danger" @click="handleCloseFirstModal"
                    >{{ setText('yes') }}</b-button
                    >
                </div>
            </div>
        </b-modal>
        <error-modal
            @shown="errorMessageModal = false"
            :show="errorMessageModal"
            :table-data="historyData"
            :request-level="currentAlteration.level"
            @onApprove="onApprove"
        ></error-modal>
        <b-modal
            v-model="flc5Modal"
            centered
            hide-header
            hide-footer
            size="lg"
        >
            <div class="flc-modal">
                <div class="flc-modal__title" style="font-size: 24px; color: #6087a0;">{{ setText('warning') }}</div>
                <hr>
                <div style="color: red; font-size: 16px;">
                    <strong>{{ setText('messages.flc5') }}</strong>
                </div>
                <br/>
                <div v-if="flc5Data" class="mt-1 p-1" style="background: #f8f9fa; border-radius: 4px; font-size: 14px; color: #6087a0;">
                    <div v-if="formattedFlc5Codes.obligations.length" class="mb-3">
                        <strong>{{ setText('obligation') }}:</strong>
                        <div class="d-flex flex-wrap">
                            <b-badge v-for="(line, index) in formattedFlc5Codes.obligations" :key="'obl_'+index" variant="light" class="m-1 border text-wrap text-left" style="max-width: 100%; white-space: normal;">
                                {{ line }}
                            </b-badge>
                        </div>
                    </div>

                    <div v-if="formattedFlc5Codes.payments.length" class="mb-3">
                        <strong>{{ setText('payments') }}:</strong>
                        <div class="d-flex flex-wrap">
                            <b-badge v-for="(line, index) in formattedFlc5Codes.payments" :key="'pay_'+index" variant="light" class="m-1 border text-wrap text-left" style="max-width: 100%; white-space: normal;">
                                {{ line }}
                            </b-badge>
                        </div>
                    </div>

                </div>
                <hr>
                <div class="d-flex justify-content-end">
                    <b-button class="mt-3" variant="primary" @click="flc5Modal = false">
                        {{ setText('close') }}
                    </b-button>
                    <b-button v-if="flc5Data.action === 'warning'" class="mt-3" variant="danger" @click="flcControl(); flc5Modal = false;"
                    >{{ setText('continue') }}</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import VueElementLoading from "vue-element-loading";
import Multiselect from 'vue-multiselect';
import CSpfTreeTable from "./SpfTreeTable";
import CSpfAddItemModal from "./CSpfAddItemModal";
import CIncomeAddItemModal from "./CIncomeAddItemModal";
import CIncomeTreeTable from "./IncomeTreeTable";
import store from "@/services/store";
import CBudgetAgreementModal from "@/modules/budget/alteration/form/tabs/components/budget-agreement-modal";
import CBudgetAgreementHistModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-hist-modal";
import SpfImportFromFileModal
    from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfImportFromFileModal.vue';
import {Ax} from "@/utils";
import axios from "axios";
import errorModal from "@/modules/budget/alteration/form/tabs/errorModal";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import moment from "moment";
import i18nService from "@/services/i18n";
import CAlterationSelectModal
    from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/CAlterationSelectModal';
import { applyIncomeMonthValue, clearPlanMonths } from '@/modules/budget/alteration/utils/income-remains';
import CReasonModal from '@/modules/budget/alteration/form/tabs/components/CreateForm/reasons/CReasonModal.vue';
import {
    REASON_EDIT_STATUSES,
    groupReasons,
    loadReasons as fetchReasons,
    loadReferenceReasons as fetchReferenceReasons
} from '@/modules/budget/alteration/form/tabs/components/CreateForm/reasons/alteration-reason-api';
// Справка (расходы) с примечаниями - новый пункт меню "Скачать" (EAK-623): сборка строк дерева
// abp/prg/ppr/spf/project для POST /api-py/alteration-reference-expenses/ (см. downloadReferenceExpenses())
import { buildReferenceExpensesSheet } from '@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTables/reference-expenses-export';

// Названия полей плана по месяцам (используется при совмещении плана специфики/проекта с формой)
const PLAN_MONTHS = ['january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'];

export default {
    name: "newAlterationForm",
    components: { DatePicker,
        Multiselect,
        CSpfTreeTable,
        'c-inc-add-modal': CIncomeAddItemModal,
        'c-spf-add-modal': CSpfAddItemModal,
        'c-inc-tree-table': CIncomeTreeTable,
        'loading': VueElementLoading,
        'c-budg-agr-modal': CBudgetAgreementModal,
        'c-budg-agr-hist-modal': CBudgetAgreementHistModal,
        SpfImportFromFileModal,
        'error-modal': errorModal,
        'c-alteration-select-modal': CAlterationSelectModal,
        'c-reason-modal': CReasonModal
    },
    mixins: [ AlterationI18nMixin ],
    props: {
        currentAlteration: Object,
        currAbp: null,
        currGu: null,
        currRegion: null,
        guBase: null,
        listAlteration: null,
        accessLevel: {},
        moduleCode: null,
        mode: null,
        newRequest: null,
        activeTab: String,
        tableType: Number,
        tabIndex: Number,
        tabCode: String,
        isLoadToJournalEnabled: Boolean,
        isTransfert: Boolean,
        requestTypeOptions: {}
    },
    created() {
        this.$watch('locale', this.localeChange);
    },
    beforeUpdate() {
        if (this.formObligation !== null) {
            this.formObligation.forEach((row) => {
                if (row.hasOwnProperty('childVis')) {
                    if (row.childVis) {
                        row._rowVariant = 'info';
                    }
                }
            });
        }

        if (this.formPayment !== null) {
            this.formPayment.forEach((row) => {
                if (row.hasOwnProperty('childVis')) {
                    if (row.childVis) {
                        row._rowVariant = 'info';
                    }
                }
            });
        }
    },
    data() {
        return {
            tableData: [],
            currDate: `${new Date()}`,
            currYear: `${new Date().getFullYear()}`,
            currMonth: `${new Date().getMonth() + 1}`,
            monthArr: [],
            currPrg: {},
            prgList: [],
            currPpr: [],
            pprList: [],
            currSpf: [],
            spfList: [],
            obligations: [],
            payments: [],
            obligationRes: [],
            paymentRes: [],
            spfText: '',
            formObligation: [],
            formObligationPlan: [],
            formPayment: [],
            formPaymentPlan: [],
            formIncome: [],
            showObligation: true,
            showPayment: true,
            spfArray: [],
            loading: false,
            selectedAlteration: null,
            agrBtnLst: { back: [], forward: [] },
            operationCode: [],
            agrEnabled: false,
            showAddItemModal: false,
            showIncomAddItemModal: false,
            showImportFileModal: false,
            importTypeTable: 1,
            textErrFlk3: this.$t('modules.budget_execution_alteration.flc.flc3'),
            defMonth: 0,
            flc1: '',
            flc2: '',
            flc3: '',
            flc4: '',
            flc6: '',
            butBlock: 0,
            butBlock2: 0,
            ost: false,
            ostIncome: false,
            // Данные по доходам тянем один раз при открытии: обычные и разнесённые ("Остатки").
            // Тумблер дальше переключает наборы в памяти, сервис повторно не дёргается.
            incomeData: null,
            incomeDataOst: null,
            guList: [],
            centeredModal: true,
            abp261gu: null,
            departGU: [],
            arrObligation: [],
            arrPayment: [],
            parentStatus: false,
            arrFlc: [],
            flcText: '',
            closingMessageModal: false,
            errorMessageModal: false,
            historyData: [],
            approveData: {},
            lsOstatkiFilter: 'budget_alteration_ost',
            lsOstatkiIncomeFilter: 'budget_alteration_income_ost',
            requestTypes: 1,
            historyTransfersButton: false,
            ds420_list: [
                {value: 0, text: this.$t('modules.budget_execution_alteration.ds_420_intgration')},
                {value: 1, text: this.$t('modules.budget_execution_alteration.ds_420_loader')}
            ],
            ds420: 0,
            withGu_list: [
                {value: false, text: this.$t('modules.budget_execution_alteration.by_abp')},
                {value: true, text: this.$t('modules.budget_execution_alteration.by_gu')}
            ],
            oDS420: [],
            pDS420: [],
            oOst420: [],
            pOst420: [],
            appsList: [],
            incParam: [],
            planPayMap: new Map(),
            planOblMap: new Map(),
            // Реестры плана по проектам в разрезе специфики: ключ - getSpfKey(специфика), значение - Map<expense_code, planChildRow>
            planPayProjectMap: new Map(),
            planOblProjectMap: new Map(),
            regionLvl6: [],
            flc5Data: {},
            flc5Modal: false, // Флаг для новой модалки FLC5
            showSelectModal: false,
            withGu: false,
            // Примечания (причины отклонения), сгруппированные по ключу спецификации/проекта: заявка АБП - EAK-1557,
            // справка (расходы) - причины всех консолидированных заявок АБП, ключ с кодом АБП - EAK-808
            reasonGroups: {}
        };
    },
    async mounted() {
        this.loading = true;
        this.ost = (store.state._instanceCode !== '35' && this.monthArr.length > 0);
        if (!this.reqType){
            await this.loadDictBudgRegLvl6();
        }
        if (localStorage[this.lsOstatkiFilter] !== undefined) {
            this.ost = JSON.parse(localStorage[this.lsOstatkiFilter]);
            this.arrChange();
        }
        // Режим "Остатки" по доходам восстанавливаем до загрузки данных, чтобы и план,
        // и значения справки сразу пришли скорректированными (isAdjusted)
        if (!this.reqType && localStorage[this.lsOstatkiIncomeFilter] !== undefined) {
            this.ostIncome = JSON.parse(localStorage[this.lsOstatkiIncomeFilter]);
        }
        this.incParam.push({
            date: new Date(this.currentAlteration.date),
            budget_levels: this.budget_levels
        });
        await this.getFlk();
        await this.loadingArrData();
        await this.loadReasons();
        await this.loadFlkCheckAgreement();
        const date = new Date(this.currentAlteration.date);
        const month = this.padLeadingZeros(date.getMonth() + 1, 2);
        this.currYear = date.getFullYear();
        this.currDate = new Date(this.currentAlteration.date);
        this.currMonth = parseInt(month);
        for (const item of this.listAlteration) {
            if (item.code === this.currentAlteration.requestType) {
                this.selectedAlteration = item;
            }
        }
        if (((this.reqType && this.currentAlteration.level === 'gu' && [1, 3, 69, 94].includes(this.currentAlteration.status.status) && this.roleIncludes('gu_edit')) || (!this.reqType && this.currentAlteration.level === 'uf' && [1, 27, 69, 94].includes(this.currentAlteration.status.status) && this.roleIncludes('uf_edit'))) && (this.accessLevel.editAccess)) {
            for (let i = this.currMonth - 1; i < 12; i++) {
                this.monthArr.push(i);
            }
        }
        if (this.currentAlteration.level === 'abp' && [261].includes(this.currentAlteration.abp)) {
            // 261 abp
            await this.loadDepartGU();
        }
        if (this.monthArr.length > 0) {
            this.defMonth = this.currMonth - 1;
        }
        if (this.formObligationFact !== undefined) {
            this.traverseAndAssign(this.formObligationFact, 0, true);
        }
        this.nameLocale(this.formObligation);

        if (this.formPaymentFact !== undefined) {
            this.traverseAndAssign(this.formPaymentFact, 1, true);
        }
        this.nameLocale(this.formPayment);

        this.arrObligation = this.formObligation.slice();
        this.arrPayment = this.formPayment.slice();

        this.buildIncomeTree();
        if (!(this.currentAlteration.level === 'gu')) {
            this.butBlock = 0;
            this.butBlock2 = 0;
        }
        if (['gu', 'abp'].includes(this.currentAlteration.level)) {
            this.butBlock = 0;
            this.butBlock2 = 0;
            this.flk1Check(this.formObligation, this.formPayment, this.formPaymentPlan, 1);
            this.flk1Check(this.formPayment, this.formObligation, this.formObligationPlan, 0);
            this.flk3Check(this.formObligation, this.formPayment);
            this.flk3Check(this.formPayment, this.formObligation);
        }
        await this.loadOperations();
        await this.agreementEvent(false);
        this.$watch('currentAlteration', () => {
            this.agreementEvent(false);
            this.currDate = this.currentAlteration.date;
        }, { deep: true });
        this.parentStatus = (this.currentAlteration.parent !== null && ![1, 27, 28].includes(this.currentAlteration.parentInfo.status.status));
        await this.loadApplicationsTitle();
        this.loading = false;
        await this.loadSettingsHist();
    },
    computed: {
        refSPF() {
            if (this.spfText.length > 0) { return this.spfText; }
            else { return '' }
        },
        refDate() {
            const date = new Date(this.currDate);
            return date.toLocaleDateString();
        },
        reqType() {
            return (!['budget_income_clarification', 'budget_income', 'budget_income_movement'].includes(this.currentAlteration.requestType));
        },
        // --- Колонка "Примечание" (причина отклонения) - только заявка АБП, разрез "по АБП" (EAK-1557) ---
        reasonAvailable() {
            return this.reqType && this.tabCode === 'requestABP' && this.currentAlteration.level === 'abp';
        },
        // Справки (расходы): примечания консолидированных заявок АБП, только просмотр, разрез "по АБП" (EAK-808)
        referenceReasonAvailable() {
            return this.reqType && this.tabCode === 'reference_expenses' && this.currentAlteration.level === 'uf';
        },
        reasonVisible() {
            return (this.reasonAvailable || this.referenceReasonAvailable) && !this.withGu;
        },
        reasonEditable() {
            return this.reasonAvailable && !!this.accessLevel.editAccess
                && REASON_EDIT_STATUSES.includes(this.currentAlteration.status?.status);
        },
        uSumVisible() {
            if (this.currentAlteration.requestType === 'budget_adjustment') {
                return 1;
            }
            else if (this.currentAlteration.requestType === 'budget_clarification') {
                return 2;
            }
            else { return 0; }
        },
        createdMonths() {
            return new Date(this.currentAlteration.date).getMonth();
        },
        locale(){
            return this.$i18n.locale;
        },
        filteredApps() {
            const s = this.selectedAlteration;
            const m = this.accessLevel.modules;
            const p = this.accessLevel.position;
            const t = this.activeTab;

            const rules = {
                9: () => s && m==='005.002.008' && !t,
                10: () => s && m==='005.002.008' && !t,
                20: () => m==='005.002.002' && !t,
                21: () => m==='005.002.002' && !t,
                1: () => s && m==='005.002.001' && t==='uf',
                2: () => s && m==='005.002.001' && t==='uf',
                5: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                11: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                6: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                12: () => s && m==='005.002.003' && (p==='abp' || p==='uf' || p===''),
                15: () => s && m==='005.002.001' && t==='uf',
                3: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                13: () => s && (
                    (m==='005.002.001' && p==='abp' && t==='ipf') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                16: () => s && m==='005.002.001' && t==='uf',
                4: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                14: () => s && (
                    (m==='005.002.001' && p==='abp' && t==='ipf') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                // Приложение 36 (по учреждениям) — видимость идентична id=3 (FPR34)
                24: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                // Приложение 38 (по учреждениям) — видимость идентична id=4 (FPR36)
                25: () => s && (
                    (m==='005.002.001' && p==='abp') ||
                    (m==='005.002.003' && (p==='abp' || p==='uf' || p==='') && t==='abp') ||
                    (m==='005.002.007' && p==='abp')
                ),
                7: () => s && m==='005.002.002' && t==='uf',
                8: () => s && m==='005.002.002' && t==='uf',
                22: () => s && m==='005.002.002' && t==='uf',
                23: () => s && m==='005.002.002' && t==='uf',
            };

            return this.appsList.filter(app => rules[app.id]?.());
        },
        budget_levels() {
            if (!this.currRegion?.code) {
                return 2; // или null, или другое значение по умолчанию
            }
            const code = this.currRegion.code;
            if (Object.values(this.regionLvl6).map(String).includes(code)) {
                return 6;
            } else if (code.endsWith('0101')) {
                return 2;
            } else if (code.endsWith('01')) {
                return 3;
            } else {
                return 4;
            }
        },
        hasActiveStep79() {
            if (!this.agrBtnLst.forward.length) return true;
            return !this.agrBtnLst.forward.some(el =>  el.code === 79);
        },
        hasStatus79() {
            return ![54, 55, 56, 58, 59, 60, 61, 79].includes(this.currentAlteration.status.status);
        },
        formattedFlc5Codes() {
            const result = {
                obligations: [],
                payments: []
            };

            const processList = (list) => {
                const grouped = {};
                list.forEach(item => {
                    // Формируем основной код связки
                    const prg = this.padLeadingZeros(item.prg, 3) || '000';
                    const ppr = this.padLeadingZeros(item.ppr, 3) || '000';
                    const spf = this.padLeadingZeros(item.spf, 3) || '000';
                    const key = `${prg}.${ppr}.${spf}`;

                    if (!item.used) {
                        if (!grouped[key]) {
                            grouped[key] = new Set();
                        }
                    }
                });
                // Преобразуем в массив строк для рендеринга
                return Object.keys(grouped).map(key => {
                    const projects = Array.from(grouped[key]);
                    return projects.length ? `${key} (${projects.join(', ')})` : key;
                });
            };

            if (this.flc5Data) {
                if (Array.isArray(this.flc5Data.obligations)) {
                    result.obligations = processList(this.flc5Data.obligations);
                }
                if (Array.isArray(this.flc5Data.payments)) {
                    result.payments = processList(this.flc5Data.payments);
                }
            }
            return result;
        },
        // Определяем, является ли пользователь отделом МСУ
        isUserMSU() {
            const regionCode = this.currentAlteration?.region || "";
            if (!regionCode) return false;
            const codeStr = regionCode.toString();
            // Проверка: не заканчивается на 00 и не заканчивается на 01
            return !codeStr.endsWith('00') && !codeStr.endsWith('01');
        }
    },
    methods: {
        traverseAndAssign(items, type, newEl) {
            items.forEach(item => {
                // Присваиваем свойство
                this.combinationsArrays(item, type, newEl);
                // Рекурсивно обрабатываем детей
                if (item.child_list?.length) {
                    this.traverseAndAssign(item.child_list, type, newEl);
                }
            });
        },
        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            this.$emit('openFilterByRef', refName);
            let refItem;
            switch (refName) {
                case 'dateRef':
                    refItem = this.$refs.dateRef;
                    break;
                case 'prgRef':
                    refItem = this.$refs.prgRef;
                    break;
                case 'pprRef':
                    refItem = this.$refs.pprRef;
                    break;
                case 'spfRef':
                    refItem = this.$refs.spfRef;
                    break;
                case 'refAlteration':
                    refItem = this.$refs.refAlteration;
                    break;
                case 'filterGu':
                    refItem = this.$refs.filterGu;
                    break;
                case 'refDepartGU':
                    refItem = this.$refs.refDepartGU;
                    break;
                case 'refWithGu': refItem = this.$refs.refWithGu; break;

                default: break;
            }
            setTimeout(() => refItem.$el.focus(), 100);
        },
        onBack() {
            this.$emit('onBack', false, this.currentAlteration);
        },
        onSave() {
            this.$bvModal.msgBoxConfirm(
                this.setText('on_save'),
                {
                    title: this.setText('confirm'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.setText('yes'),
                    cancelTitle: this.setText('canc'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        if (this.reqType) {
                            this.loading = true;
                            this.tableData = [];
                            this.save(this.formObligation);
                            this.save(this.formPayment);
                            fetch("/api/budget-execution-alteration?requestId=" + this.currentAlteration.id, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                method: "POST",
                                body: JSON.stringify(this.tableData)
                            })
                                .then((res) => this.makeToast('success', this.setText('message'), this.setText('data_saved')),  this.loading = false)
                                .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()),  this.loading = false);
                            this.loadFlkCheckAgreement();
                        } else {
                            this.loading = true;
                            this.tableData = [];
                            this.save(this.formIncome);
                            fetch("/api/budget-execution-alteration/income?requestId=" + this.currentAlteration.id, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                method: "POST",
                                body: JSON.stringify(this.tableData)
                            })
                                .then((res) => this.makeToast('success',  this.setText('message'), this.setText('data_saved')),  this.loading = false)
                                .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()),  this.loading = false);
                        }

                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.setText('errors.save'), error.toString());
                });
        },
        getSum(obj) {
            let sum = 0;
            for (let i=0; i < 12; i++) {
                if (obj[`month${i}`]) {
                    sum = Math.round(((typeof obj[`month${i}`] == 'number' ? obj[`month${i}`] : parseFloat(obj[`month${i}`])) + sum)*10)/10;
                }
            }
            return sum;
        },
        getPlanVal(obj) {
            return PLAN_MONTHS[obj];
        },
        normalizePpr(ppr) {
            return ppr === 0 ? null : ppr;
        },
        save: function (dataTable) {
            if (this.reqType) {
                dataTable.forEach(item => {
                    [...Array(12)].map((_, i) => {
                        let lm = i;
                        if (item.child_list?.length > 0) {
                            // Check if any child has non-zero value for this month
                            const hasChildWithValue = item.child_list.some(child => child['month_' + i] !== 0);

                            if (hasChildWithValue) {
                                lm = item.leftMonth >= i ? item.leftMonth : i;
                                this.tableData.push({
                                    id: null,
                                    budgetExecutionAlterationRequestId: this.currentAlteration.id,
                                    region: this.currentAlteration.region,
                                    year: item.year,
                                    gu: item.gu,
                                    gr: item.gr,
                                    abp: item.abp,
                                    prg: item.prg,
                                    ppr: this.normalizePpr(item.ppr),
                                    spf: item.spf,
                                    planType: item.planType,
                                    expense_code: item.expense_code,
                                    month: i,
                                    value: item['month_' + i] * 1,
                                    leftMonth: lm,
                                    left_amount: item.left_amount
                                });
                            }
                            else {
                                if (item['month_' + i] !== 0) {
                                    lm = item.leftMonth >= i ? item.leftMonth : i;
                                    this.tableData.push({
                                        id: null,
                                        budgetExecutionAlterationRequestId: this.currentAlteration.id,
                                        region: this.currentAlteration.region,
                                        year: item.year,
                                        gu: item.gu,
                                        gr: item.gr,
                                        abp: item.abp,
                                        prg: item.prg,
                                        ppr: this.normalizePpr(item.ppr),
                                        spf: item.spf,
                                        planType: item.planType,
                                        expense_code: item.expense_code,
                                        month: i,
                                        value: item['month_' + i] * 1,
                                        leftMonth: lm,
                                        left_amount: item.left_amount
                                    });
                                }
                            }
                        }
                        else {
                            if (item['month_' + i] !== 0) {
                                if (item.leftMonth >= i) {
                                    lm = item.leftMonth;
                                } else {
                                    lm = i;
                                }
                                this.tableData.push({
                                    id: null,
                                    budgetExecutionAlterationRequestId: this.currentAlteration.id,
                                    region: this.currentAlteration.region,
                                    year: item.year,
                                    gu: item.gu,
                                    gr: item.gr,
                                    abp: item.abp,
                                    prg: item.prg,
                                    ppr: this.normalizePpr(item.ppr),
                                    spf: item.spf,
                                    planType: item.planType,
                                    expense_code: item.expense_code,
                                    month: i,
                                    value: item['month_' + i] * 1,
                                    leftMonth: lm,
                                    left_amount: item.left_amount
                                });
                            }
                        }
                    });
                    item.child_list?.forEach(child => {
                        [...Array(12)].map((_, j) => {
                            let lmj = j;
                            if (child['month_' + j] !== 0) {
                                if (child.leftMonth >= j) {
                                    lmj = child.leftMonth;
                                } else {
                                    lmj = j;
                                }
                                this.tableData.push({
                                    id: null,
                                    budgetExecutionAlterationRequestId: this.currentAlteration.id,
                                    region: item.region,
                                    year: item.year,
                                    gu: item.gu,
                                    gr: item.gr,
                                    abp: item.abp,
                                    prg: item.prg,
                                    ppr: this.normalizePpr(item.ppr),
                                    spf: item.spf,
                                    planType: item.planType,
                                    expense_code: child.expense_code,
                                    month: j,
                                    value: child['month_' + j] * 1,
                                    leftMonth: lmj,
                                    left_amount: child.left_amount
                                });
                            }
                        });
                    });
                });
            } else {
                dataTable.forEach(elKat => {
                    elKat.child_list.forEach(
                        elClss => {
                            elClss.child_list.forEach(
                                elPcl => {
                                    elPcl.child_list.forEach(
                                        item => {
                                            // В таблице доходов нет аналога left_month, поэтому текущий месяц
                                            // и все предыдущие (куда разложились остатки) уходят на бэк
                                            // одной суммой текущего месяца
                                            const curMonth = this.createdMonths;
                                            let curSum = 0;
                                            for (let m = 0; m <= curMonth; m++) {
                                                curSum = Math.round((curSum + (item['month' + m] * 1 || 0)) * 10) / 10;
                                            }
                                            [...Array(12)].map((_, i) => {
                                                if (i < curMonth) {
                                                    return;
                                                }
                                                const monthValue = i === curMonth ? curSum : item['month' + i] * 1;
                                                if (monthValue !== 0) {
                                                    this.tableData.push({
                                                        id: null,
                                                        budgetExecutionAlterationRequestId: this.currentAlteration.id,
                                                        region: this.currRegion.code,
                                                        year: this.currYear,
                                                        kat: item.kat,
                                                        cls: item.clss,
                                                        pcl: item.pcl,
                                                        spf: item.spf,
                                                        month: i,
                                                        value: monthValue
                                                    })
                                                }
                                            });
                                        }
                                    )
                                }
                            )
                        }
                    )
                });
            }
        },
        chgDataObl(data) {
            try {
                this.arrFlc = [];
                this.formObligation = JSON.parse(JSON.stringify(data.tableData)); // Глубокое копирование
                this.butBlock = 0;
                this.butBlock2 = 0;

                const row1 = { ...this.formObligation[data.indx] }; // Копируем объект, а не ссылку

                this.applyMonthChange(row1, data.fieldName);
                if (row1.child_list && Array.isArray(row1.child_list)) {
                    for (const child of row1.child_list) {
                        this.applyMonthChange(child, data.fieldName);
                    }
                }

                this.flk1Check(this.formObligation, this.formPayment, this.formPaymentPlan, 1);
                this.formObligation.splice(data.indx, 1, row1);
                this.flk3Check(this.formObligation, this.formPayment);
                this.flk3Check(this.formPayment, this.formObligation);
            } catch (error) {
                this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
            }
        },
        // Пересчитывает month_i/month{i} по введённому значению текущего месяца. Используется как для
        // строки специфики, так и для каждого её проекта (child_list) - чтобы отрицательное значение
        // текущего месяца одинаково "съедало" остатки предыдущих месяцев на обоих уровнях. Для проекта
        // getPlanVal/planSumOst читают его собственный помесячный план (assignProjectPlan), поэтому если
        // план не детализирован до проекта (все месяцы 0) - используется ветка без перераспределения.
        applyMonthChange(row, fieldName) {
            const curMonth = parseFloat(fieldName.toString().slice(5));
            const resetMonths = (obj, startMonth) => {
                for (let i = startMonth - 1; i > -1; i--) {
                    obj[`month_${i}`] = 0;
                    obj[`month${i}`] = 0;
                }
            };

            row.leftMonth = this.defMonth;
            if (curMonth === this.defMonth) {
                row.left_amount = row[fieldName];
                row.flk = { sum: [] };
                resetMonths(row, this.defMonth);
                if (row[fieldName] < 0) {
                    if (this.planSumOst(row, this.defMonth + 1) >= Math.abs(row[fieldName])) {
                        let diff = row[fieldName] + (row[this.getPlanVal(curMonth)] >= 0 ? row[this.getPlanVal(curMonth)] : 0);
                        if (diff < 0) {
                            row.sum_val = row[fieldName];
                            const planVal = row[this.getPlanVal(curMonth)];
                            if (planVal > 0) {
                                row[fieldName] = -Math.abs(planVal);
                                row[`month_${curMonth}`] = -parseFloat(planVal);
                            } else {
                                row[fieldName] = 0;
                                row[`month_${curMonth}`] = 0;
                            }

                            for (let i = this.defMonth - 1; i > -1; i--) {
                                if (row[this.getPlanVal(i)] > 0) {
                                    diff += row[this.getPlanVal(i)];
                                    if (diff <= 0) {
                                        row[`month_${i}`] = -Math.round(parseFloat(row[this.getPlanVal(i)])*10)/10;
                                    } else {
                                        row[`month_${i}`] = -Math.round(parseFloat(row[this.getPlanVal(i)] - diff)*10)/10;
                                        break;
                                    }
                                } else {
                                    row[`month_${i}`] = 0;
                                }
                            }

                            if (this.ost) {
                                for (let i = this.defMonth; i > -1; i--) {
                                    row[`month${i}`] = row[`month_${i}`];
                                }
                            } else {
                                row[`month${curMonth}`] = row.left_amount;
                            }
                        } else {
                            row[`month_${curMonth}`] = row[fieldName];
                        }
                    } else {
                        row[`month_${curMonth}`] = row[fieldName];
                    }
                } else {
                    resetMonths(row, this.defMonth);
                    row[`month_${curMonth}`] = row[fieldName];
                }
            } else {
                row[`month_${curMonth}`] = row[fieldName];
            }
        },
        chgDataPay(data) {
            try {
                this.arrFlc = [];
                this.formPayment = JSON.parse(JSON.stringify(data.tableData));
                this.butBlock = 0;
                this.butBlock2 = 0;
                const row1 = { ...this.formPayment[data.indx] };

                this.applyMonthChange(row1, data.fieldName);
                if (row1.child_list && Array.isArray(row1.child_list)) {
                    for (const child of row1.child_list) {
                        this.applyMonthChange(child, data.fieldName);
                    }
                }

                this.flk1Check(this.formPayment, this.formObligation, this.formObligationPlan, 0);
                this.formPayment.splice(data.indx, 1, row1);
                // FLK3
                this.flk3Check(this.formPayment, this.formObligation);
                this.flk3Check(this.formObligation, this.formPayment);
            } catch (error) {
                this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
            }
        }, // обновление параметров
        planSum(data, month) {
            let sum = 0;
            for (let i = month - 1; i > -1; i--) {
                const value = data[this.getPlanVal(i)];
                // Добавляем только положительные значения
                sum = parseFloat((Math.round((sum + value) * 10) / 10).toFixed(1));
            }
            return sum;
        },
        planSumOst(data, month) {
            let sum = 0;
            for (let i = month - 1; i > -1; i--) {
                const value = data[this.getPlanVal(i)];
                // Добавляем только положительные значения
                if (value > 0) {
                    sum = parseFloat((Math.round((sum + value) * 10) / 10).toFixed(1));
                }
            }
            return sum;
        },
        monthSum(data, month) {
            let sum = 0;
            for (let i = month - 1; i > -1; i--) {
                sum = parseFloat((Math.round((sum + data['month' + i])* 10) / 10).toFixed(1));
            }
            return sum;
        },
        // FLK1
        flk1Check(arr, arr2, arrP, type) {
            if (arr.length !== 0) {
                for (let j = 0; j < arr.length; j++) {
                    const row1 = arr[j];
                    const row2 = this.findRow(row1, arr2);
                    const row2Old = JSON.parse(JSON.stringify(row2));
                    for (let i = 0; i < 12; i++) {
                        if (row2 !== null) {
                            switch (type) {
                                case 0:   // payment
                                    if (Math.round((this.monthSum(row1, i + 1) + this.planSum(row1, i + 1)) * 10) / 10 > Math.round((this.monthSum(row2, i + 1) + this.planSum(row2, i + 1)) * 10) / 10) {
                                        if (!row1.flk) { row1.flk = {}; }
                                        if (!row1.flk[`month${i}`]) { row1.flk[`month${i}`] = []; }
                                        row1.flk[`month${i}`] = [];
                                        row1.flk[`month${i}`].push({
                                            id: 1,
                                            typeErr: this.flc1,
                                            textErr: this.setText('flc.flc1')
                                        });
                                        row2.flk[`month${i}`] = [];
                                        row2.flk[`month${i}`].push({
                                            id: 1,
                                            typeErr: this.flc1,
                                            textErr: this.setText('flc.flc1')
                                        });
                                        this.flcCheck(this.arrFlc, {
                                            id: 1,
                                            typeErr: this.flc1,
                                            textErr: this.setText('flc.flc1Txt')
                                        });
                                        this.butBlock2 = this.butBlock2 + 1;
                                        this.agrBtn(this.flc1.length > 0);
                                    } else {
                                        if (row1.flk !== undefined || row1.flk[`month${i}`] !== undefined){
                                            row1.flk[`month${i}`] = [];
                                        }
                                        if (row2.flk !== undefined || row2.flk[`month${i}`] !== undefined) {
                                            row2.flk[`month${i}`] = [];
                                        }
                                    }
                                    break;
                                case 1:   // obligation
                                    if (Math.round((this.monthSum(row1, i + 1) + this.planSum(row1, i + 1)) * 10) / 10 < Math.round((this.monthSum(row2, i + 1) + this.planSum(row2, i + 1)) * 10) / 10) {
                                        // if (row1.sums[i] > row2.sums[i]) {
                                        if (!row1.flk) { row1.flk = {}; }
                                        if (!row1.flk[`month${i}`]) { row1.flk[`month${i}`] = []; }
                                        row1.flk[`month${i}`] = [];
                                        // if (row1[`month${i}`] !== 0 && row2[`month${i}`] !== 0) {
                                        // }

                                        row1.flk[`month${i}`].push({
                                            id: 1,
                                            typeErr: this.flc1,
                                            textErr: this.setText('flc.flc1')
                                        });
                                        row2.flk[`month${i}`] = [];
                                        row2.flk[`month${i}`].push({
                                            id: 1,
                                            typeErr: this.flc1,
                                            textErr: this.setText('flc.flc1')
                                        });
                                        this.flcCheck(this.arrFlc, {
                                            id: 1,
                                            typeErr: this.flc1,
                                            textErr: this.setText('flc.flc1Txt')
                                        });
                                        this.butBlock2 = this.butBlock2 + 1;
                                        this.agrBtn(this.flc1.length > 0);
                                    } else {
                                        if (row1.flk !== undefined || row1.flk[`month${i}`] !== undefined){
                                            row1.flk[`month${i}`] = [];
                                        }
                                        if (row2.flk !== undefined || row2.flk[`month${i}`] !== undefined) {
                                            row2.flk[`month${i}`] = [];
                                        }
                                    }
                                    break;
                            }
                            if (JSON.stringify(row2.flk) !== JSON.stringify(row2Old.flk)) {
                                arr2.splice(row2.index, 1, row2);
                            }
                            arr2.splice(row2.index, 1, row2);
                        } else {
                            const row2 = this.findRow(row1, arrP);
                            if (row2 !== null) {
                                switch (type) {
                                    case 0:   // payment
                                        if (Math.round((this.monthSum(row1, i + 1) + this.planSum(row1, i + 1)) * 10) / 10 > this.planSum(row2, i + 1)) {
                                            row1.flk[`month${i}`] = [];
                                            if (!row1.flk) { row1.flk = {}; }
                                            if (!row1.flk[`month${i}`]) { row1.flk[`month${i}`] = []; }
                                            if (!row2.flk) { row2.flk = {}; }
                                            if (!row2.flk[`month${i}`]) { row2.flk[`month${i}`] = []; }
                                            row1.flk[`month${i}`].push({
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1')
                                            });
                                            this.flcCheck(this.arrFlc, {
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1')
                                            });
                                            this.butBlock2 = this.butBlock2 + 1;
                                            this.agrBtn(this.flc1.length > 0);
                                        } else {
                                            row1.flk[`month${i}`] = [];
                                        }
                                        break;
                                    case 1:   // obligation
                                        if (Math.round((this.monthSum(row1, i + 1) + this.planSum(row1, i + 1)) * 10) / 10 < this.planSum(row2, i + 1)) {
                                            row1.flk[`month${i}`] = [];
                                            if (!row1.flk) { row1.flk = {}; }
                                            if (!row1.flk[`month${i}`]) { row1.flk[`month${i}`] = []; }
                                            if (!row2.flk) { row2.flk = {}; }
                                            if (!row2.flk[`month${i}`]) { row2.flk[`month${i}`] = []; }
                                            row1.flk[`month${i}`].push({
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1')
                                            });
                                            this.flcCheck(this.arrFlc, {
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1Txt')
                                            });
                                            this.butBlock2 = this.butBlock2 + 1;
                                            this.agrBtn(this.flc1.length > 0);
                                        } else {
                                            row1.flk[`month${i}`] = [];
                                        }
                                        break;
                                }
                            }
                            else {
                                switch (type) {
                                    case 0:   // payment
                                        if (Math.round((this.monthSum(row1, i + 1) + this.planSum(row1, i + 1)) * 10) / 10 > 0) {
                                            row1.flk[`month${i}`] = [];
                                            if (!row1.flk) { row1.flk = {}; }
                                            if (!row1.flk[`month${i}`]) { row1.flk[`month${i}`] = []; }
                                            row1.flk[`month${i}`].push({
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1')
                                            });
                                            this.flcCheck(this.arrFlc, {
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1Txt')
                                            });
                                            this.butBlock2 = this.butBlock2 + 1;
                                            this.agrBtn(this.flc1.length > 0);
                                        } else {
                                            row1.flk[`month${i}`] = [];
                                        }
                                        break;
                                    case 1:
                                        if (Math.round((this.monthSum(row1, i + 1) + this.planSum(row1, i + 1)) * 10) / 10 < 0) {
                                            row1.flk[`month${i}`] = [];
                                            if (!row1.flk) { row1.flk = {}; }
                                            if (!row1.flk[`month${i}`]) { row1.flk[`month${i}`] = []; }
                                            row1.flk[`month${i}`].push({
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1')
                                            });
                                            this.flcCheck(this.arrFlc, {
                                                id: 1,
                                                typeErr: this.flc1,
                                                textErr: this.setText('flc.flc1Txt')
                                            });
                                            this.butBlock2 = this.butBlock2 + 1;
                                            this.agrBtn(this.flc1.length > 0);
                                        } else {
                                            row1.flk[`month${i}`] = [];
                                        }
                                        break;
                                }
                            }
                        }
                    }
                }
            }
        },
        findRow(row1, data2) {
            if (!data2 || data2.length === 0) return null;

            for (let j = 0; j < data2.length; j++) {
                const row2 = data2[j];

                // Проверка условий
                if (row1.gu === row2.gu &&
                    row1.prg === row2.prg &&
                    row1.spf === row2.spf &&
                    (row1.expense_code === '' || row1.expense_code === null) &&
                    (row1.ppr === row2.ppr ||
                        ((row1.ppr == null || row1.ppr === 0) && (row2.ppr == null || row2.ppr === 0)))) {

                    row2.index = j;
                    return row2;
                }
            }

            return null;
        },
        findParentRow(row1, data2) {
            if (!data2 || data2.length === 0) return null;

            for (let j = 0; j < data2.length; j++) {
                const row2 = data2[j];

                // Проверка условий
                if (row1.gu === row2.gu &&
                    row1.prg === row2.prg &&
                    row1.spf === row2.spf &&
                    (row1.expense_code === '' || row1.expense_code === null) &&
                    (row1.ppr === row2.ppr ||
                        ((row1.ppr == null || row1.ppr === 0) && (row2.ppr == null || row2.ppr === 0))) &&
                    row1.plan_type === row2.plan_type
                ) {

                    row2.index = j;
                    return row2;
                }
            }

            return null;
        },
        findRowTr(row1, data2) {
            if (!data2?.length) return null; // Проверка на пустой массив или null/undefined

            for (let j = 0; j < data2.length; j++) {
                const row2 = data2[j];

                if (row1.gu === row2.gu &&
                    row1.prg === row2.prg &&
                    row1.spf === row2.spf &&
                    row1.expense_code !== '' &&
                    row1.expense_code !== null &&
                    row2.expense_code !== '' &&
                    row2.expense_code !== null &&
                    row1.expense_code === row2.expense_code &&
                    (row1.ppr === row2.ppr ||
                        ((row1.ppr == null || row1.ppr === 0) && (row2.ppr == null || row2.ppr === 0)))
                    ) {

                    row2.index = j; // Сохраняем индекс, если это необходимо
                    return row2;
                }
            }

            return null; // Если элемент не найден
        },
        flk3Check(data1, data2) {
            if (data1.length !== 0) {
                for (let i = 0; i < data1.length; i++) {
                    const row1 = data1[i];
                    const row1Old = JSON.parse(JSON.stringify(row1));
                    if (!row1.flk) { row1.flk = {}; }
                    if (!row1.flk[`sum`]) { row1.flk[`sum`] = []; }
                    for (let i = 0; i < 12; i++) {
                        if (!row1.flk[`month${i}`]) {
                            row1.flk[`month${i}`] = [];
                        }
                    }
                    if (!row1Old.flk) { row1Old.flk = {}; }
                    if (!row1Old.flk[`sum`]) { row1Old.flk[`sum`] = []; }
                    row1.flk.sum = [];
                    const row2 = this.findRow(row1, data2);
                    if (row2 !== null) {
                        if (this.getSum(row1) !== this.getSum(row2)) {
                            row1.flk.sum[row1.flk.sum.length] = { id: 3, typeErr: this.flc3, textErr: this.textErrFlk3 };
                            this.flcCheck(this.arrFlc, { id: 3, typeErr: this.flc3, textErr: this.textErrFlk3 });
                            this.butBlock2 = this.butBlock2 + 1;
                            this.agrBtn(this.flc3.length > 0);
                        }
                    } else {
                        if (this.getSum(row1) !== 0) {
                            row1.flk.sum[row1.flk.sum.length] = { id: 3, typeErr: this.flc3, textErr: this.textErrFlk3 };
                            this.flcCheck(this.arrFlc, { id: 3, typeErr: this.flc3, textErr: this.textErrFlk3 });
                            this.butBlock2 = this.butBlock2 + 1;
                            this.agrBtn(this.flc3.length > 0);
                        }
                    }
                    if (JSON.stringify(row1.flk.sum) !== JSON.stringify(row1Old.flk.sum)) {
                        data1.splice(i, 1, row1);
                    }
                }
            }
        },
        agrBtn(val) {
            if (val) {
                this.butBlock = this.butBlock + 1;
            }
        },
        chgDataIncome(data, changed) {
            try {
                this.butBlock = 0;
                this.butBlock2 = 0;
                this.formIncome = data;
                this.syncIncomeCache(changed);
            } catch (error) {
                this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
            }
        }, // обновление параметров
        // Введённое значение сразу пересчитываем в обоих наборах: в обычном - как ввели,
        // в наборе "Остатки" - с раскладкой по остаткам его собственного плана. Иначе
        // переключение тумблера вернуло бы данные в том виде, в каком они пришли при открытии.
        syncIncomeCache(changed) {
            if (!changed) {
                return;
            }
            [[this.incomeData, false], [this.incomeDataOst, true]].forEach(([dataSet, spread]) => {
                if (!dataSet || !Array.isArray(dataSet.fact)) {
                    return;
                }
                const row = this.ensureIncomeRow(dataSet.fact, changed);
                if (!row) {
                    return;
                }
                const plan = (dataSet.plan || []).find((item) => item.kat === changed.kat
                    && item.cls === changed.clss && item.pcl === changed.pcl && item.spf === changed.spf);
                applyIncomeMonthValue(row, plan, this.createdMonths, changed.fieldName, changed.value, spread);
            });
        },
        // Ищет строку специфики в наборе, а если её там нет (специфику добавили на форме) -
        // переносит ветку из текущего дерева, чтобы правка не потерялась при переключении
        ensureIncomeRow(fact, key) {
            const clssOf = (el) => (el.clss !== undefined ? el.clss : el.cls);
            const findNode = (list, match) => (list || []).find(match);
            const copyNode = (node) => Object.assign({}, node, { child_list: [] });

            const srcKat = findNode(this.formIncome, (el) => el.kat === key.kat);
            let kat = findNode(fact, (el) => el.kat === key.kat);
            if (!kat) {
                if (!srcKat) {
                    return null;
                }
                kat = copyNode(srcKat);
                fact.push(kat);
            }
            const srcClss = findNode(srcKat && srcKat.child_list, (el) => clssOf(el) === key.clss);
            let clss = findNode(kat.child_list, (el) => clssOf(el) === key.clss);
            if (!clss) {
                if (!srcClss) {
                    return null;
                }
                clss = copyNode(srcClss);
                kat.child_list.push(clss);
            }
            const srcPcl = findNode(srcClss && srcClss.child_list, (el) => el.pcl === key.pcl);
            let pcl = findNode(clss.child_list, (el) => el.pcl === key.pcl);
            if (!pcl) {
                if (!srcPcl) {
                    return null;
                }
                pcl = copyNode(srcPcl);
                clss.child_list.push(pcl);
            }
            let spf = findNode(pcl.child_list, (el) => el.spf === key.spf);
            if (!spf) {
                const srcSpf = findNode(srcPcl && srcPcl.child_list, (el) => el.spf === key.spf);
                if (!srcSpf) {
                    return null;
                }
                // план в наборе хранится отдельно, суммы проставит applyIncomeMonthValue
                spf = clearPlanMonths(Object.assign({}, srcSpf));
                for (let i = 0; i < 12; i++) {
                    spf[`month${i}`] = 0;
                }
                pcl.child_list.push(spf);
            }
            return spf;
        },
        toggleShowObligation() {
            this.showObligation = !this.showObligation;
        },
        toggleShowPayment() {
            this.showPayment = !this.showPayment;
        },
        dsChange() {
            // Устанавливаем остатки с проверкой на пустые массивы
            this.oOstatki = this.ds420 === 0 ?
                (this.oOst420?.length ? this.oOst420 : []) :
                (this.oDS420?.length ? this.oDS420 : []);

            this.pOstatki = this.ds420 === 0 ?
                (this.pOst420?.length ? this.pOst420 : []) :
                (this.pDS420?.length ? this.pDS420 : []);

            // Функция для сравнения элементов
            const isItemsMatch = (item, itemO) => {
                return item.abp === itemO.abp &&
                    item.gu === itemO.gu &&
                    item.prg === itemO.prg &&
                    item.spf === itemO.spf &&
                    // Специальная логика для ppr (null/0 считаем эквивалентными)
                    ((item.ppr === itemO.ppr) ||
                        ((!item.ppr || item.ppr === 0) && (!itemO.ppr || itemO.ppr === 0)));
            };

            // Функция обновления с оптимизацией
            const updateItems = (items, ostatki, ostField) => {
                if (!ostatki.length) {
                    // Если остатков нет - обнуляем все
                    items.forEach(item => {
                        item.ost = 0;
                        item.ostDate = null;
                    });
                    return;
                }

                items.forEach(item => {
                    const foundOstatok = ostatki.find(itemO => isItemsMatch(item, itemO));
                    if (foundOstatok) {
                        item.ost = foundOstatok[ostField] || 0;
                        item.ostDate = foundOstatok.ostDate || null;
                    } else {
                        item.ost = 0;
                        item.ostDate = null;
                    }
                });
            };

            // Применяем обновления
            updateItems(this.formObligation, this.oOstatki, 'ostO');
            updateItems(this.formPayment, this.pOstatki, 'ostP');
        },
        async loadingArrData () {
            const el = Object.assign({}, this.currentAlteration);
            el.year = this.currYear;
            let params = JSON.stringify(el);
            let abp = null;
            const guSet = new Set();
            if (this.reqType) {
                if (this.currAbp !== null) {
                    abp = this.currAbp.abp;
                }
                try {
                    let resT = '';
                    params = `{"year":${this.currYear},"abp":${abp},"gu":"${this.currentAlteration.gu}","region":"${this.currRegion.code}","type":"obligation","requestId":"${this.currentAlteration.id}","requestType":"${this.currentAlteration.requestType}","budgetVersion":"${this.currentAlteration.budgetVersion}","level":"${this.currentAlteration.level}","date":"${this.formatDate(new Date(this.currentAlteration.date))}"}`;
                    resT = await fetch(
                        `/api-py/get-alteration-new-data/` + params);
                    const arrDate = await resT.json();
                    const arrDateCopy = JSON.parse(JSON.stringify(arrDate));
                    this.formObligationPlan = [];
                    this.formObligationPlan = arrDateCopy?.plan;
                    this.formObligationFact = [];
                    this.formObligationFact = arrDateCopy?.fact;
                    for (const item of arrDateCopy?.guList) {
                        guSet.add(item);
                    }
                    this.oOstatki = [];
                    this.oOstatki = this.ds420 === 0
                        ? arrDateCopy?.ost
                        : arrDateCopy?.ostDS;
                    this.oDS420 = arrDateCopy?.ostDS;
                    this.oOst420 = arrDateCopy?.ost;
                    this.formObligationPlan.forEach((item) => {
                        this.$set(item, 'sum', item.month0 + item.month1 + item.month2 + item.month3 + item.month4 +
                            item.month5 + item.month6 + item.month7 + item.month8 + item.month9 + item.month10 + item.month11);
                        const key = this.getItemKey(item);
                        this.planOblMap.set(key, item);
                        // Регистрируем план по проектам этой специфики (если он есть) и убираем служебное поле из строки плана
                        this.registerProjectPlan(item, this.planOblProjectMap);
                    });
                }  catch (error) {
                    this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
                    this.loading = false;
                }
                try {
                    let resP = '';
                    params = `{"year":${this.currYear},"abp":${abp},"gu":"${this.currentAlteration.gu}","region":"${this.currRegion.code}","type":"payment","requestId":"${this.currentAlteration.id}","requestType":"${this.currentAlteration.requestType}","budgetVersion":"${this.currentAlteration.budgetVersion}","level":"${this.currentAlteration.level}","date":"${this.formatDate(new Date(this.currentAlteration.date))}"}`;
                    resP = await fetch(
                        `/api-py/get-alteration-new-data/` + params);
                    const arrDate =  await resP.json();
                    const arrDateCopy = JSON.parse(JSON.stringify(arrDate));
                    this.formPaymentPlan = [];
                    this.formPaymentPlan = arrDateCopy?.plan;
                    this.formPaymentFact = [];
                    this.formPaymentFact = arrDateCopy?.fact;
                    for (const item of arrDateCopy?.guList) {
                        guSet.add(item);
                    }
                    this.pOstatki = [];
                    // this.pOstatki = arrDate?.ost;
                    this.pOstatki = this.ds420 === 0
                        ? arrDateCopy?.ost
                        : arrDateCopy?.ostDS;
                    this.pDS420 = arrDateCopy?.ostDS;
                    this.pOst420 = arrDateCopy?.ost;
                    this.formPaymentPlan.forEach((item) => {
                        this.$set(item, 'sum', item.month0 + item.month1 + item.month2 + item.month3 + item.month4 +
                            item.month5 + item.month6 + item.month7 + item.month8 + item.month9 + item.month10 + item.month11);
                        const key = this.getItemKey(item);
                        this.planPayMap.set(key, item);
                        // Регистрируем план по проектам этой специфики (если он есть) и убираем служебное поле из строки плана
                        this.registerProjectPlan(item, this.planPayProjectMap);
                    });
                }  catch (error) {
                    this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
                    this.loading = false;
                }
                this.guList = Array.from(guSet);
                await this.loadUserGU();
            } else {
                this.formIncome = [];
                try {
                    const [incomeData, incomeDataOst] = await Promise.all([
                        this.loadIncomeData(false),
                        this.loadIncomeData(true)
                    ]);
                    this.incomeData = incomeData;
                    this.incomeDataOst = incomeDataOst;
                    this.setIncomeData();
                } catch (error) {
                    this.makeToast('danger',  this.setText('errors.err'), error.toString());
                    this.loading = false;
                }
            }
        },
        formatDate(date) {
            const d = new Date(date);
            let month = '' + (d.getMonth() + 1);
            let day = '' + d.getDate();
            const year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        },
        duplicatedData(type) {
            // type: 1 — дублировать из платежей в обязательства, 0 — из обязательств в платежи
            const source = JSON.parse(JSON.stringify(type === 0 ? this.formObligation : this.formPayment));
            this.butBlock = 0;
            this.butBlock2 = 0;
            if (!source || source.length === 0) return;

            // Тип/planType целевой стороны для combinationsArrays/buildNewSpecSeed(Child) - используется,
            // когда на целевой стороне вообще нет строки (не была сохранена, т.к. была нулевой до сохранения)
            const targetCombType = type === 0 ? 1 : 0; // combinationsArrays: 0 - обязательства, 1 - платежи
            const targetPlanType = targetCombType === 0 ? 1 : 2; // plan_type/planType: 1 - обязательства, 2 - платежи (см. addedItems)
            const targetProjectMap = targetCombType === 0 ? this.planOblProjectMap : this.planPayProjectMap;

            source.forEach(sourceItem => {
                const leftMonth = sourceItem.leftMonth ?? this.defMonth;

                // 1. Суммируем month0..month{leftMonth} источника
                let totalSum = 0;
                for (let i = 0; i <= leftMonth; i++) {
                    const val = sourceItem[`month${i}`] || 0;
                    totalSum = Math.round((totalSum + val) * 10) / 10;
                }

                // 2. Ищем соответствующую строку в целевом массиве
                const target = type === 0 ? this.formPayment : this.formObligation;
                let targetItem = this.findRow(sourceItem, target);
                if (!targetItem) {
                    // Целевой строки специфики нет вообще - справка была сохранена без неё (сумма была
                    // нулевой и не дублировалась до сохранения). Строим затравку и добавляем её в целевой
                    // массив через combinationsArrays - как это делает addedItems() для новой позиции,
                    // план целевой стороны (formObligationPlan/formPaymentPlan) подтянется автоматически.
                    const seed = this.buildNewSpecSeed(sourceItem, targetPlanType);
                    this.combinationsArrays(seed, targetCombType, true);
                    targetItem = this.findRow(sourceItem, target);
                    if (!targetItem) return;
                }
                // 3. Сбрасываем все месяцы в целевой строке
                for (let i = 0; i < 12; i++) {
                    targetItem[`month${i}`] = 0;
                    targetItem[`month_${i}`] = 0;
                }

                // 4. Записываем суммарное значение в поле leftMonth и применяем
                //    тот же механизм пересчёта остатков, что и при ручном вводе (applyMonthChange)
                const fieldName = `month${leftMonth}`;
                targetItem[fieldName] = totalSum;
                this.applyMonthChange(targetItem, fieldName);
                // Для месяцев после текущего (defMonth+1 .. 11) — копируем значения напрямую,
                // т.к. applyMonthChange для curMonth !== defMonth только выставляет month_i = fieldName
                for (let i = this.defMonth + 1; i < 12; i++) {
                    const val = sourceItem[`month${i}`] || 0;
                    targetItem[`month${i}`] = val;
                    targetItem[`month_${i}`] = val;
                }
                // Обновляем left_amount по значению текущего месяца источника
                targetItem.left_amount = leftMonth;
                targetItem.leftMonth = sourceItem.leftMonth ?? this.defMonth;

                // 5. Обрабатываем дочерние элементы (child_list) аналогично
                if (sourceItem.child_list && Array.isArray(sourceItem.child_list)) {
                    // Важно присвоить массив обратно в targetItem.child_list, если его не было -
                    // иначе targetChildList останется локальной переменной, не связанной со строкой
                    if (!Array.isArray(targetItem.child_list)) { targetItem.child_list = []; }
                    const targetChildList = targetItem.child_list;

                    sourceItem.child_list.forEach(sourceChild => {
                        let targetChild = targetChildList.find(
                            c => c.expense_code === sourceChild.expense_code
                        );
                        if (!targetChild) {
                            // Дочерней строки проекта на целевой стороне нет - строим затравку и подтягиваем
                            // план целевой стороны по этому же проекту (если детализирован), тем же приёмом,
                            // что и updateFormData при добавлении нового проекта пользователем
                            targetChild = this.buildNewChildSeed(sourceChild, targetPlanType);
                            this.assignProjectPlan(targetChild, targetProjectMap);
                            targetChildList.push(targetChild);
                        }

                        const childLeftMonth = sourceChild.leftMonth ?? leftMonth;

                        // Суммируем month0..month{childLeftMonth} дочернего источника
                        let childTotal = 0;
                        for (let i = 0; i <= childLeftMonth; i++) {
                            const val = sourceChild[`month${i}`] || 0;
                            childTotal = Math.round((childTotal + val) * 10) / 10;
                        }

                        // Сбрасываем месяцы дочерней целевой строки
                        for (let i = 0; i < 12; i++) {
                            targetChild[`month${i}`] = 0;
                            targetChild[`month_${i}`] = 0;
                        }

                        // Применяем тот же механизм пересчёта остатков (applyMonthChange)
                        const childFieldName = `month${childLeftMonth}`;

                        targetChild[childFieldName] = childTotal;
                        this.applyMonthChange(targetChild, childFieldName);
                        // Последующие месяцы — прямое копирование
                        for (let i = this.defMonth + 1; i < 12; i++) {
                            const val = sourceChild[`month${i}`] || 0;
                            targetChild[`month${i}`] = val;
                            targetChild[`month_${i}`] = val;
                        }

                        targetChild.left_amount = childTotal;
                        targetChild.leftMonth = sourceChild.leftMonth ?? this.defMonth;
                    });
                }
            });

            // 6. Запускаем ФЛК-проверки после дублирования
            if (type === 0) {
                this.flk1Check(this.formObligation, this.formPayment, this.formPaymentPlan, 1);
                this.flk3Check(this.formObligation, this.formPayment);
                this.flk3Check(this.formPayment, this.formObligation);
            } else {
                this.flk1Check(this.formPayment, this.formObligation, this.formObligationPlan, 0);
                this.flk3Check(this.formPayment, this.formObligation);
                this.flk3Check(this.formObligation, this.formPayment);
            }
        },
        // Строит "затравку" для отсутствующей на другой стороне строки специфики: сохраняет
        // идентифицирующие поля исходной строки (gu/prg/ppr/spf/abp/названия и т.п.), но обнуляет
        // всё, что специфично для типа (план, остатки, суммы, child_list) - их подставит
        // combinationsArrays из плана целевой стороны (formObligationPlan/formPaymentPlan)
        buildNewSpecSeed(sourceRow, planType) {
            const seed = JSON.parse(JSON.stringify(sourceRow));
            seed.plan_type = planType;
            seed.planType = planType;
            seed.expense_code = null;
            delete seed.child_list;
            seed.ost = 0;
            seed.ostDate = null;
            seed.utochSum = 0;
            seed.flk = {};
            for (let i = 0; i < 12; i++) {
                seed[`month${i}`] = 0;
                seed[`month_${i}`] = 0;
            }
            // sum/plan/january..december - план целевой стороны (см. combinationsArrays: Object.assign({}, itemP, item) -
            // itemP - строка плана целевой стороны). Их нужно удалить, а не занулить: seed клонирован из sourceRow и
            // уже несёт план ИСХОДНОЙ стороны по этим же ключам - если оставить их (даже равными 0) как собственные
            // ключи seed, они как более поздний аргумент Object.assign перезапишут реальный план целевой стороны из
            // itemP. Без этих ключей combinationsArrays корректно подставит план целевой стороны, если он есть,
            // либо оставит 0 по умолчанию (zeroItem), если плана нет.
            delete seed.sum;
            delete seed.plan;
            PLAN_MONTHS.forEach(month => { delete seed[month]; });
            return seed;
        },
        // Строит "затравку" для отсутствующей на целевой стороне дочерней строки проекта (child_list):
        // сохраняет идентифицирующие поля исходного проекта (abp/gu/prg/ppr/spf/expense_code/названия и т.п.),
        // обнуляет суммы/месяцы/флк. combinationsArrays для строк с expense_code ничего не пушит (см. её код),
        // поэтому план целевой стороны по этому же проекту подтягивается не ею, а assignProjectPlan - её нужно
        // вызвать отдельно после этого метода (см. duplicatedData), как это делает updateFormData при добавлении
        // нового проекта пользователем.
        buildNewChildSeed(sourceChild, planType) {
            const seed = JSON.parse(JSON.stringify(sourceChild));
            seed.plan_type = planType;
            seed.planType = planType;
            delete seed.child_list;
            seed.ost = 0;
            seed.ostDate = null;
            seed.utochSum = 0;
            seed.flk = {};
            for (let i = 0; i < 12; i++) {
                seed[`month${i}`] = 0;
                seed[`month_${i}`] = 0;
            }
            // sum/plan/planByProject/january..december - см. аналогичный комментарий в buildNewSpecSeed;
            // удаляем план исходной стороны, чтобы assignProjectPlan ниже корректно подставил план целевой
            delete seed.sum;
            delete seed.plan;
            delete seed.planByProject;
            PLAN_MONTHS.forEach(month => { delete seed[month]; });
            return seed;
        },
        getItemKey(item) {
            return `${item.abp}-${item.gu}-${item.prg}-${item.ppr}-${item.spf}-${item.expense_code || ''}`;
        },
        // Ключ специфики (без учёта expense_code) для реестров плана по проектам; ППР null и 0 - одно и то же
        getSpfKey(item) {
            return `${item.gu}-${item.prg}-${item.ppr || 0}-${item.spf}`;
        },
        // Регистрирует план по проектам конкретной специфики (plan_child_list) в реестре и убирает служебное поле
        // из плановой строки - оно не должно попасть в строки формы через Object.assign в combinationsArrays
        registerProjectPlan(specRow, projectMap) {
            const planChildList = specRow.plan_child_list;
            delete specRow.plan_child_list;
            if (!Array.isArray(planChildList) || !planChildList.length) { return; }
            const projectsBySpf = new Map();
            for (const planChild of planChildList) {
                projectsBySpf.set(planChild.expense_code, planChild);
            }
            projectMap.set(this.getSpfKey(specRow), projectsBySpf);
        },
        // Совмещает плановые значения строки проекта (нижнего уровня справки) с планом по этому же проекту.
        // Если специфика не детализирована в плане до проектов (ключа в реестре нет) - ничего не меняем,
        // контроль остаётся на уровне специфики, как и раньше.
        assignProjectPlan(child, projectMap) {
            const projectsBySpf = projectMap.get(this.getSpfKey(child));
            if (!projectsBySpf) { return; }
            const planItem = projectsBySpf.get(child.expense_code);
            for (const month of PLAN_MONTHS) {
                this.$set(child, month, planItem ? (planItem[month] || 0) : 0);
            }
            this.$set(child, 'plan', planItem ? (planItem.plan || 0) : 0);
            this.$set(child, 'planByProject', true);
        },
        async loadFlkCheckAgreement() {
            const response = await fetch('/api/budget-execution-alteration-flk/check/agreement-2?requestId=' + this.currentAlteration.id);
            this.flc5Data = await response.json();
        },
        // Загрузка и группировка примечаний (причин отклонения): заявки АБП (EAK-1557) либо справки (EAK-808)
        async loadReasons() {
            if (!this.reasonAvailable && !this.referenceReasonAvailable) { return; }
            try {
                if (this.reasonAvailable) {
                    const list = await fetchReasons(this.currentAlteration.id);
                    this.reasonGroups = groupReasons(list);
                } else {
                    this.reasonGroups = await fetchReferenceReasons(this.currentAlteration.id);
                }
            } catch (error) {
                this.makeToast('danger', this.setText('reason.load_error'), error.toString());
            }
        },
        openReasonModal(target) {
            if (this.$refs.refReasonModal) { this.$refs.refReasonModal.open(target); }
        },
        // Справки (расходы): просмотр примечания по иконке в ячейке - модалка в режиме просмотра (EAK-808)
        openReasonViewModal(group) {
            if (this.$refs.refReasonModal) { this.$refs.refReasonModal.view(group); }
        },
        async loadOperations() {
            this.operationCode = [];
            if (store.state.user.sub === null) { return; }
            let result = null;
            try {
                result = await fetch(encodeURI(`/api/um/module/link?user=${store.state.user.sub}&modulecode=${this.moduleCode}`))
                    .then(response => response.json());
            } catch (error) {
                this.makeToast('danger',  this.setText('errors.user_operation'), error.toString());
                return;
            }
            if (result.operations) { this.operationCode = result.operations; }
        },
        async loadUserGU() {
            try {
                const response = await fetch('/api-py/user-gu/' + store.state.user.sub);
                const data = await response.json();
                const arr = [];
                // for (const item of data) {
                //     arr.push(item['gu']);
                // }
                // const difference = this.guList.filter((item) =>
                //     !arr.includes(item));
                // this.difference = difference.slice();
            } catch (error) {
                this.makeToast('danger',  this.setText('errors.ga') + store.state.user.sub, error.toString());
            }
        },
        handleCloseFirstModal() {
            this.agreementEvent();
            this.closingMessageModal = false;
        },
        handleCloseSecondModal() {
            this.closingMessageModal = false;
        },
        flcControls(val){
            this.flcCheck(this.arrFlc, val);
            this.butBlock2 = this.butBlock2 + 1;
        },
        async flcActions(){
            this.tableData = [];

            if (this.reqType) {
                this.save(this.formObligation);
                this.save(this.formPayment);
                await fetch("/api/budget-execution-alteration?requestId=" + this.currentAlteration.id, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify(this.tableData)
                })
                await this.loadFlkCheckAgreement();
                if ([1, 3].includes(this.currentAlteration.status.status) && ['block', 'warning'].includes(this.flc5Data.action)) {
                    this.flc5Modal = true;
                } else {
                    this.flcControl();
                }
            }
            else {
                this.save(this.formIncome);
                await fetch("/api/budget-execution-alteration/income?requestId=" + this.currentAlteration.id, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify(this.tableData)
                })
                this.flcControl();
            }

        },
        flcControl(){
            if (this.butBlock2 > 0 && [1, 3].includes(this.currentAlteration.status.status) &&
                (this.reqType ? this.currentAlteration.level === 'gu' : this.currentAlteration.level === 'uf')
            ) {
                this.arrFlc = this.arrFlc.sort((a, b) => (a.id - b.id > 0 ? 1 : -1));
                this.closingMessageModal = true;
            } else {
                this.agreementEvent();
            }
        },
        // кнопка действия
        async agreementEvent(show = true) {
            let statusResult = this.currentAlteration.status.status;
            try {
                const response = await fetch(`/api-py/get-status-update/${encodeURI(JSON.stringify({requestId: this.currentAlteration.id}))}`);
                statusResult = await response.json();
            } catch (error) {
                this.makeToast('danger',  this.setText('errors.err') + ' get-status-update', error.toString());
                return;
            }
            this.selectArr = [];
            const params = { modeCode: this.mode, operationCode: this.operationCode, agrCode: statusResult };
            if (!show) { this.agrEnabled = false; }
            let result = null;
            try {
                const response = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
                result = await response.json();
                this.nameLocale(result)
            } catch (error) {
                this.makeToast('danger',  this.setText('errors.err') + ' get-agreement-step-next-back', error.toString());
                return;
            }
            if (result.length === 0) {
                this.makeToast('warning',  this.setText('agreement'),  this.setText('nosteps'));
                return;
            }
            this.agrBtnLst = { back: [], forward: [] };
            for (const el of result) {
                if (el.stepType === 1) {
                    if (this.currentAlteration.parent !== null && (this.roleIncludes('abp_educ') || ![1, 27, 28].includes(this.currentAlteration.parentInfo?.status?.status))) {
                        this.$set(el, 'disabled', true);
                    }
                    this.agrBtnLst.back.push(el);
                } else {
                    if (this.butBlock > 0 && (this.reqType ? [2, 35, 26, 31, 68] : [26, 68]).includes(el.code)) {
                        this.$set(el, 'disabled', true);
                    }
                    // Проверяем, нужно ли пропустить добавление
                    let shouldSkip = false;
                    shouldSkip = (this.currentAlteration.status.status === 32 &&
                        this.currentAlteration.level === 'abp' &&
                        this.currentAlteration.parent === null &&
                        el.code === 79);
                    if (!shouldSkip) {
                        this.agrBtnLst.forward.push(el);
                    }
                }
            }
            if (this.agrBtnLst.back.length || this.agrBtnLst.forward.length) {
                this.agrEnabled = true;
            }
            if (show) { this.$refs.refAgrModal.showEvent(); }
        },
        async agrFind(data) {
            const status = this.currentAlteration.status.status;
            data.userId = store.state.user.sub;
            const saveObj = Object.assign({ bearId: this.currentAlteration.id }, data);
            let result = await fetch('/api-py/set_bear_agreement_step',
                {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify(saveObj)
                });
            if (result.status === 200) {
                result = await result.json();
                if (result.result === 'success') {
                    // if (['abp'].includes(this.currentAlteration.level)){
                    //     if (result.data.__data__.status === 39){
                    //         await fetch('/api-py/status-39-save/' + JSON.stringify(saveObj),
                    //             {
                    //                 method: 'POST',
                    //                 mode: 'cors',
                    //                 cache: 'no-cache',
                    //                 credentials: 'same-origin',
                    //                 headers: {
                    //                     'Content-Type': 'application/json'
                    //                 },
                    //                 redirect: 'follow',
                    //                 referrerPolicy: 'no-referrer'
                    //             });
                    //     }
                    //     if (status === 39){
                    //         const saveObject = Object.assign({ statusBack: 35 }, saveObj);
                    //         await fetch('/api-py/status-39-save/' + JSON.stringify(saveObject),
                    //             {
                    //                 method: 'POST',
                    //                 mode: 'cors',
                    //                 cache: 'no-cache',
                    //                 credentials: 'same-origin',
                    //                 headers: {
                    //                     'Content-Type': 'application/json'
                    //                 },
                    //                 redirect: 'follow',
                    //                 referrerPolicy: 'no-referrer'
                    //             });
                    //     }
                    // }

                    this.currentAlteration.status.status = result.data.__data__.status;
                    this.$watch('currentAlteration', () => {
                        this.agreementEvent(false);
                    }, { deep: true });
                    this.makeToast('success', this.setText('status_save'), 'Успешно');
                } else {
                    this.makeToast('danger', this.setText('status_save'), this.setText('errors.err') + ` ${result.data}`);
                }
                this.$emit('onBack', false, this.currentAlteration);
            } else {
                this.makeToast('danger', this.setText('status_save'), this.setText('errors.err') + ` ${result.status} ${result.statusText}`);
            }
        },
        async agrClick(data) {
            if ([3, 28].includes(data.status) && (this.currentAlteration.parent !== null)) {
                this.$bvModal.msgBoxConfirm(
                    this.setText('flc.except') + this.currentAlteration.parentInfo.number + this.setText('flc.except2'),
                    {
                        title: this.setText('confirmation'),
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: this.setText('yes'),
                        cancelTitle: this.setText('canc'),
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                        if (value) {
                            const req = { requestId: null, childID: this.currentAlteration.id };
                            try {
                                fetch(`/api-py/consolidate-request-list-save/${encodeURI(JSON.stringify(req))}`, {
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    method: "POST"
                                })
                                    .then((res) => { this.makeToast('success', this.setText('message'), this.setText('flc.exception') + `${this.currentAlteration.parentInfo.number}.`);
                                        this.currentAlteration.parent = null;
                                        this.agrFind(data);
                                    })
                                    .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()));
                            } catch (error) {
                                this.makeToast('danger', this.setText('errors.err') + ' consolidate-request-list-save', error.toString());
                            }
                        }
                    });
            } else {
                if ([26].includes(data.status) && (this.currentAlteration.level === 'uf')) {
                    // sohranyayu v udget_execution_alteration_history
                    // requestId - id заявки УФ
                    try {
                        const hisData = await fetch(`/api/budget-execution-alteration-history/check?requestId=${this.currentAlteration.id}`)
                            .then(response => response.json());
                        this.historyData = [];
                        hisData.alterationData.forEach((item, index) => {
                            hisData.historyData.forEach((item_, index_) => {
                                if (item.abp === item_.abp && item.prg === item_.prg && item.month === item_.month && item.planType === item_.planType && item.value !== item_.value) {
                                    this.historyData.push({
                                        "abp": item.abp,
                                        "prg": item.prg,
                                        "month": item.month,
                                        "valueH": item_.value,
                                        "valueC": item.value,
                                        "type": item.planType
                                    });
                                }
                            })
                        });
                        if (hisData.status === false && this.historyData.length > 0) {
                            this.approveData = data;
                            this.errorMessageModal = true;
                        } else {
                            // await this.agrFind(data);
                            fetch(`/api/budget-execution-alteration-history/save?requestId=${this.currentAlteration.id}`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                method: "POST"
                            })
                                .then((res) => { this.agrFind(data); })
                                .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()));
                        }

                    } catch (error) {
                        this.makeToast('danger', this.setText('errors.err') + ' budget-execution-alteration-history/save', error.toString());
                    }
                } else {
                    if ([31].includes(data.status) && (this.currentAlteration.level === 'abp')) {
                        // sohranyayu v udget_execution_alteration_history
                        // requestId - id заявки УФ
                        try {
                            const hisData = await fetch(`/api/budget-execution-alteration-history/check?requestId=${this.currentAlteration.id}`)
                                .then(response => response.json());
                            this.historyData = [];
                            hisData.alterationData.forEach((item, index) => {
                                hisData.historyData.forEach((item_, index_) => {
                                    if (item.prg === item_.prg && item.month === item_.month && item.planType === item_.planType && item.value !== item_.value) {
                                        this.historyData.push({
                                            "prg": item.prg,
                                            "month": item.month,
                                            "valueH": item_.value,
                                            "valueC": item.value,
                                            "type": item.planType
                                        });
                                    }
                                })
                            });
                            if (hisData.status === false && this.historyData.length > 0) {
                                this.approveData = data;
                                this.errorMessageModal = true;
                            } else {
                                await this.agrFind(data);
                            }
                        } catch (error) {
                            this.makeToast('danger', this.setText('errors.err') + ' budget-execution-alteration-history/check', error.toString());
                        }
                    } else {
                        if ([2, 68].includes(data.status)) {
                            if (this.reqType) {
                                this.loading = true;
                                this.tableData = [];
                                this.save(this.formObligation);
                                this.save(this.formPayment);
                                fetch("/api/budget-execution-alteration?requestId=" + this.currentAlteration.id, {
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    method: "POST",
                                    body: JSON.stringify(this.tableData)
                                })
                                    .then((res) => this.makeToast('success', this.setText('message'), this.setText('data_saved')),  this.loading = false)
                                    .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()),  this.loading = false);
                            } else {
                                this.loading = true;
                                this.tableData = [];
                                this.save(this.formIncome);
                                fetch("/api/budget-execution-alteration/income?requestId=" + this.currentAlteration.id, {
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    method: "POST",
                                    body: JSON.stringify(this.tableData)
                                })
                                    .then((res) => this.makeToast('success', this.setText('message'), this.setText('data_saved')),  this.loading = false)
                                    .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()),  this.loading = false);
                            }
                            await this.agrFind(data);
                        } else {
                            if ([79].includes(data.status)) {
                                if ([79].includes(data.status) && !['requestGA'].includes(this.tabCode)) {
                                    this.showSelectModal = true;
                                }
                            } else {
                                await this.agrFind(data);
                            }
                        }
                    }
                }
            }
        },
        onApprove(val) {
            if (val) {
                if (this.currentAlteration.level === 'uf'){
                    fetch(`/api/budget-execution-alteration-history/save?requestId=${this.currentAlteration.id}`, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        method: "POST"
                    })
                        .then((res) => { this.agrFind(this.approveData); })
                        .catch((err) => this.makeToast('danger', this.setText('errors.save'), err.toString()));
                } else {
                    if (this.currentAlteration.level === 'abp') {
                        this.agrFind(this.approveData);
                    }
                }

            }
        },
        importSpf(type=1) {
            this.requestTypes = 0;
            this.showImportFileModal = true
            this.importTypeTable = type
        },
        importTransfers(type=1) {
            this.requestTypes = 1;
            this.showImportFileModal = true
            this.importTypeTable = type
        },
        addItem() {
            this.showAddItemModal = true;
        },
        addItemIncome() {
            this.showIncomAddItemModal = true;
        },
        addedItems (items) {
            for (const el of items) {
                el.year = this.currYear;
                el.region = this.currRegion.code;
                el.gu = this.currentAlteration.gu;
                el.utochSum = 0;
                el.flk = {}
                el.flk.sum = [];
                for (let i=0; i < 12; i++) {
                    el.flk[`month${i}`] = [];
                }
                // el.child_list - ссылочный тип, поверхностный Object.assign даст objObligation.child_list
                // === objPayment.child_list (один и тот же массив на оба типа) - клонируем el для каждого,
                // чтобы дети специфики (в т.ч. добавляемые позже проекты) не расшаривались между формами
                const objObligation = Object.assign({plan_type: 1, planType: 1}, JSON.parse(JSON.stringify(el)));
                const objPayment = Object.assign({plan_type: 2, planType: 2}, JSON.parse(JSON.stringify(el)));
                if (!this.findRow(el, this.formObligation)) {
                    this.combinationsArrays(objObligation, 0, true);
                }
                if (!this.findRow(el, this.formPayment)) {
                    this.combinationsArrays(objPayment, 1, true);
                }
            }
        },
        addedIncomeItems (items) {
            for (const el of items) {
                // el.year = this.currYear;
                el.region = this.currRegion.code;
                const objIncome = Object.assign({ year: this.currYear }, el);
                //-----тут поля отдельные для payment и Obligation ---
                this.combinationsArrays(objIncome, -1, true);
            }
        },
        combinationsArrays(item, type, newEl) {
            // Константы и начальная настройка
            const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june',
                'july', 'august', 'september', 'october', 'november', 'december'];
            const zeroItem = MONTHS.reduce((acc, month) => ({...acc, [month]: 0}), {utochSum: 0});
            let objObligation = [];
            let objOPayment = [];
            let objIncome = []
            let findItem = false;
            let findElem = false;
            let findElemCls = false;
            let findElemPcl = false;
            let elPcl = [];
            let treeIncome = [];
            if (type >= 0) {
                for (let i = 0; i < 12; i++) {
                    item['month' + i] = 0;
                }
                if (this.ost === true) {
                    for (let i = 0; i < 12; i++) {
                        item['month' + i] = item['month_' + i];
                    }
                } else {
                    for (let i = 0; i < 12; i++) {
                        if (item.leftMonth < i) {
                            item['month' + i] = item['month_' + i];
                        } else {
                            item['month' + item.leftMonth] =  Math.round((item['month' + item.leftMonth] + item['month_' + i]) *10)/10;
                        }
                    }
                }
                if (item.expense_code) {
                    // Строка нижнего уровня (проект) - план специфики ей не подходит, подтягиваем план по этому же проекту,
                    // если он есть (детализация плана до проектов). Нужно для уже сохранённых справок при их загрузке.
                    this.assignProjectPlan(item, type === 0 ? this.planOblProjectMap : this.planPayProjectMap);
                }
            }
            if (type === 0) {
                this.formObligationPlan.forEach((itemP, index) => {
                    if (['gu'].includes(this.currentAlteration.level)) {
                        if (item['abp'] === itemP['abp'] && item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
                            (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
                            objObligation = Object.assign({}, itemP, item);
                            // Если в item нет child_list, удаляем его из результата
                            if (!('child_list' in item)) {
                                delete objObligation.child_list;
                            }
                            findItem = true;
                        }
                    } else {
                        if (['abp'].includes(this.currentAlteration.level)) {
                            if (item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
                                (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
                                objObligation = Object.assign({}, itemP, item);
                                if (!('child_list' in item)) {
                                    delete objObligation.child_list;
                                }
                                findItem = true;
                            }
                        } else {
                            if (item['abp'] === itemP['abp'] && item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
                                (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
                                objObligation = Object.assign({}, itemP, item);
                                if (!('child_list' in item)) {
                                    delete objObligation.child_list;
                                }
                                findItem = true;
                            }
                        }
                    }
                });
                if (findItem) {
                    this.oOstatki.forEach((itemO, index) => {
                        if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                            (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
                            objObligation.ost = itemO.ostO;
                            objObligation.ostDate = itemO.ostDate;
                        }
                    });
                    if (!objObligation.expense_code) {
                        this.formObligation.push(objObligation);
                    }
                } else {
                    objObligation = Object.assign(zeroItem, item);
                    this.oOstatki.forEach((itemO, index) => {
                        if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                            (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
                            objObligation.ost = itemO.ostO;
                            objObligation.ostDate = itemO.ostDate;
                        }
                    });
                    if (!objObligation.expense_code) {
                        this.formObligation.push(objObligation);
                    }
                }
            } else if (type > 0) {
                this.formPaymentPlan.forEach((itemP, index) => {
                    if (['gu'].includes(this.currentAlteration.level)) {
                        if (item['abp'] === itemP['abp'] && item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
                            (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
                            objOPayment = Object.assign({}, itemP, item);
                            if (!('child_list' in item)) {
                                delete objOPayment.child_list;
                            }
                            findItem = true;
                        }
                    } else {
                        if (['abp'].includes(this.currentAlteration.level)) {
                            if (item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
                                (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
                                objOPayment = Object.assign({}, itemP, item);
                                if (!('child_list' in item)) {
                                    delete objOPayment.child_list;
                                }
                                findItem = true;
                            }
                        } else {
                            if (item['abp'] === itemP['abp'] && item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
                                (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
                                objOPayment = Object.assign({}, itemP, item);
                                if (!('child_list' in item)) {
                                    delete objOPayment.child_list;
                                }
                                findItem = true;
                            }
                        }
                    }
                });
                if (findItem) {
                    this.pOstatki.forEach((itemO, index) => {
                        if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                            (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
                            objOPayment.ost = itemO.ostP;
                            objOPayment.ostDate = itemO.ostDate;
                        }
                    });
                    if (!objOPayment.expense_code) {
                        this.formPayment.push(objOPayment);
                    }
                } else {
                    objOPayment = Object.assign(zeroItem, item);
                    this.pOstatki.forEach((itemO, index) => {
                        if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                            (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
                            objOPayment.ost = itemO.ostP;
                            objOPayment.ostDate = itemO.ostDate;
                        }
                    });
                    if (!objOPayment.expense_code) {
                        this.formPayment.push(objOPayment);
                    }
                }
            } else if (type < 0) {
                // Функция для поиска и обработки элемента на самом глубоком уровне (spf)
                const processSpfLevel = (spfItem) => {

                    this.formIncomePlan.forEach((itemP, index) => {
                        if (spfItem['kat'] === itemP['kat'] &&
                            spfItem['clss'] === itemP['cls'] &&
                            spfItem['pcl'] === itemP['pcl'] &&
                            spfItem['spf'] === itemP['spf']) {

                            // Копируем данные по месяцам
                            const months = ['january', 'february', 'march', 'april', 'may', 'june',
                                'july', 'august', 'september', 'october', 'november', 'december'];

                            months.forEach(month => {
                                spfItem[month] = itemP[month];
                            });
                        }
                    });
                };

                const traverseHierarchy = (currentItem) => {
                    if (!currentItem.child_list || currentItem.child_list.length === 0) {
                        return;
                    }
                    currentItem.child_list.forEach(katItem => {
                        if (katItem.child_list && katItem.child_list.length > 0) {
                            katItem.child_list.forEach(clsItem => {
                                if (clsItem.child_list && clsItem.child_list.length > 0) {
                                    clsItem.child_list.forEach(pclItem => {
                                        processSpfLevel(pclItem);
                                    });
                                }
                            });
                        }
                    });
                    objIncome = currentItem;
                    findItem = true;
                };
                traverseHierarchy(item);
                if (!findItem) {
                    objIncome = Object.assign(item, zeroItem);
                    const elemCls = objIncome['child_list']
                    for (let i = 0; i < elemCls.length; i++) {
                        // Object.assign(elemCls[i], zeroItem);
                        const elemPcl = elemCls[i]['child_list']
                        for (let j = 0; j < elemPcl.length; j++) {
                            // Object.assign(elemPcl[j], zeroItem);
                            const elemSpf = elemPcl[j]['child_list']
                            for (let l = 0; l < elemSpf.length; l++) {
                                Object.assign(elemSpf[l], zeroItem);
                            }
                        }
                    }
                }
                if (newEl) {
                    treeIncome =  this.formIncome.slice();
                    for (let i = 0; i < treeIncome.length; i++) {
                        const elKat = treeIncome[i];
                        if (elKat.kat === item.kat) {
                            findElem = true;
                            for (let i = 0; i < elKat['child_list'].length; i++) {
                                const elCls = elKat['child_list'][i];
                                if (elCls.kat === item.kat && elCls.clss === item.clss) {
                                    findElemCls = true;
                                    for (let i = 0; i < elCls['child_list'].length; i++) {
                                        elPcl = elCls['child_list'][i];
                                        if (elPcl.kat === item.kat && elPcl.clss === item.clss  && elPcl.pcl === item.pcl) {
                                            findElemPcl = true;
                                            elPcl['child_list'].push(objIncome['child_list'][0]['child_list'][0]['child_list'][0]);
                                            break;
                                        }
                                    }
                                    if (!findElemPcl) {
                                        elCls['child_list'].push(objIncome['child_list'][0]['child_list'][0]);
                                        break;
                                    }
                                }
                            }
                            if (!findElemCls) {
                                elKat['child_list'].push(objIncome['child_list'][0]);
                                break;
                            }
                        }
                    }
                    if (!findElem) {
                        treeIncome.push(objIncome);
                    }
                    this.formIncome = treeIncome;
                } else {
                    this.formIncome.push(objIncome);
                }
            }
        },
        async getFlk() {
            const params = { level: this.currentAlteration.level, requestType: this.currentAlteration.requestType };
            try {
                const response = await fetch(`/api-py/get-flk/${encodeURI(JSON.stringify(params))}`);
                const flcArr = await response.json();
                for (let i = 0; i < flcArr.length; i++) {
                    switch (flcArr[i].flk) {
                        case 1:
                            if (flcArr[i].class === 1)
                                this.flc1 = 'error';
                            break;
                        case 2:
                            if (flcArr[i].class === 1)
                                this.flc2 = 'error';
                            break;
                        case 3:
                            if (flcArr[i].class === 1)
                                this.flc3 = 'error';
                            break;
                        case 4:
                            if (flcArr[i].class === 1)
                                this.flc4 = 'error';
                            break;
                        case 6:
                            if (flcArr[i].class === 1)
                                this.flc6 = 'error';
                            break;
                    }
                }
            } catch (error) {
                this.makeToast('danger', this.setText('errors.err') + ' get-flk', error.toString());
            }
        },
        async downloadApplication(app) {
            // this.loading = true;
            const item = this.currentAlteration
            const year = new Date(item.date).getFullYear();
            const date = new Date(item.date).toLocaleDateString();
            const lang = this.$i18n.locale;
            const signParams = {
                code_modules: this.accessLevel.modules,
                region: item.region,
                abp: item.abp,
                code_gu: item.gu,
                date_start_variants: moment(item.date).format('YYYY-MM-DD')
            }
            const appItem = this.appsList.find(x => x.id === app);
            // EAK-1604 (ФТ-1.3/1.4): «Приложение 36/38 (по учреждениям)» выгружается в одном
            // языковом варианте (не рус+каз, как старые пункты), поэтому имя файла и название
            // записи журнала должны идти на языке интерфейса, а не всегда по-русски, как для
            // остальных (действующих) пунктов списка.
            const appDisplayName = ([24, 25].includes(app) && lang === 'kk')
                ? (appItem.name_kz || appItem.name_ru)
                : appItem.name_ru

            let desc = ''
            if (this.tabIndex === 1) {
                desc = item.gu
            } else if (this.tabIndex === 2) {
                desc = item.abp
            } else if (this.tabIndex === 3) {
                desc = item.abp
            } else if (this.tabIndex === 4) {
                desc = item.region
            } else if (this.tabIndex === 5) {
                desc = item.region
            }

            const filename = `${appDisplayName}_${desc}_${item.number}_${date}.xlsx`

            const d = {
                'app': app,
                'id': item.id,
                'gu': item.gu,
                'date': date,
                'year': year,
                'description': item.description,
                'region': item.region,
                'number': item.number,
                'request_type': item.requestType,
                'abp': item.abp,
                'abp261gu': this.abp261gu ? this.abp261gu.childGu : [],
                'treeData': [],
                'signers': signParams,
                'level': item.level,
                'name': appDisplayName,
                'user_id': this.$store.getters.user_uuid,
                'agreement_status': item.status.status,
                'report_key': 'ALTER',
                'source_tab': this.tabCode,
                'isTransfert': this.isTransfert,
                'filename': filename,
                'lang': lang
            }
            if (this.abp261gu?.code) { // Параметр для фильтра журнала
                d['gu261_code'] = this.abp261gu.code
            }
            const appDict = {
                1: '27',
                2: '28',
                3: '34',
                4: '36',
                5: '29',
                6: '30',
                7: '37',
                8: '39',
                9: '25',
                10: '26',
                11: '29' + this.setText('downloads.notGA'),
                12: '30' + this.setText('downloads.notGA'),
                13: '34' + this.setText('downloads.notGA'),
                14: '36' + this.setText('downloads.notGA'),
                15: '33',
                16: '35',
                24: '34' + this.setText('downloads.byInstitution'),
                25: '36' + this.setText('downloads.byInstitution')
            }

            const that = this;

            if (this.isLoadToJournalEnabled) {
                // Выгрузка в журнал
                const response = await fetch('/api-py/alteration/journal', {
                    method: 'POST',
                    body: JSON.stringify(d)
                })
                if (!response.ok) {
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    return
                }
                const journalId = await response.text()
                fetch(`/api-py/alteration/journal/${journalId}`, {
                    method: 'PUT'
                })
                this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                this.$emit('reload-journal')
            } else {
                // Прямая выгрузка
                Ax(
                    {
                        url: '/api-py/alteration_application/',
                        method: 'POST',
                        responseType: 'blob',
                        data: d
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename)
                        document.body.appendChild(link);
                        link.click();
                        this.loading = false;
                    },
                    (error) => {
                        this.makeToast('danger', this.setText('errors.request') + ' downloadRep()', error.toString());
                        this.loading = false;
                    }
                )
            }
        },
        downloadReport() {
            const that = this;
            const params = JSON.stringify({
                requestId: that.currentAlteration.id,
                date: moment(that.currentAlteration.date).format('YYYY-MM-DD'),
                locale: this.$i18n.locale
            });
            let filename = ''
            switch (this.$i18n.locale) {
                case 'kk':
                    filename =`ММ бойынша міндеттемелерді тіркеуді және төлемдерді жүргізуді тоқтата тұруға арналған есеп.xls`;
                    break;
                default:
                    filename =`Отчет на приостановление регистрации обязательств и проведения платежей по ГУ.xls`;
            }
            Ax(
                {
                    url: '/api-py/blocking-report/' + encodeURI(params), //  Тело файла
                    method: 'POST',
                    data: that.ajxParams,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${filename}`);// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                }
            );

        },
        // Справка (расходы) с примечаниями - новый пункт меню "Скачать" на вкладке "Справки (расходы)" (УО),
        // EAK-623. В отличие от SVI_SPF_PO/PP (downloadFile) включает ВСЕ строки справки (и специфики/проекты
        // с примечаниями, и без) и отдельную колонку "Примечание" - эти данные уже загружены на экран
        // (formObligation/formPayment, reasonGroups), поэтому здесь только сборка JSON и скачивание файла,
        // без повторного обращения за данными. Контракт - POST /api-py/alteration-reference-expenses/ (sit-py).
        downloadReferenceExpenses() {
            const item = this.currentAlteration;
            const lang = this.$i18n.locale;
            const date = moment(item.date).format('YYYY-MM-DD');
            const currentMonth = new Date(item.date).getMonth() + 1;
            const dateForFilename = moment(item.date).format('DD.MM.YYYY');
            // Имя файла на языке выгрузки (EAK-623, замечание PM): ru - "Справка_№{number}_{date}",
            // kk - "№{number}_Анықтама_{date}" (тот же порядок слов, что в шапке самого отчёта).
            const filename = lang === 'kk'
                ? `№${item.number}_Анықтама_${dateForFilename}.xlsx`
                : `Справка_№${item.number}_${dateForFilename}.xlsx`;

            const payload = {
                lang: lang,
                number: item.number,
                date: date,
                currentMonth: currentMonth,
                sheets: {
                    payment: buildReferenceExpensesSheet(this.formPayment, this.reasonGroups, 2, lang),
                    obligation: buildReferenceExpensesSheet(this.formObligation, this.reasonGroups, 1, lang)
                }
            };

            Ax(
                {
                    url: '/api-py/alteration-reference-expenses/',
                    method: 'POST',
                    responseType: 'blob',
                    data: payload
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', this.setText('errors.request') + ' downloadReferenceExpenses()', error.toString());
                }
            );
        },
        async dataUpload(val) {
            if (val) {
                this.loading = true;
                this.formObligationFact = [];
                this.formObligation = [];
                this.formPaymentFact = [];
                this.formPayment = [];
                await this.loadingArrData();
                if (this.formObligationFact !== undefined) {
                    this.traverseAndAssign(this.formObligationFact, 0, false);
                }
                this.nameLocale(this.formObligation);

                if (this.formPaymentFact !== undefined) {
                    this.traverseAndAssign(this.formPaymentFact, 1, false);
                }
                this.nameLocale(this.formPayment);
                this.loading = false;
            }
        },
        async importObligations(arrData) {
            this.formObligation = [];
            this.formObligationFact = [];
            this.formObligationFact = arrData.fact;
            for (const el of this.formObligationFact) {
                el.year = this.currYear;
                el.region = this.currRegion.code;
                el.utochSum = el.total;
                el.flk = {}
                el.flk.sum = [];
                for (let i=0; i < 12; i++) {
                    el.flk[`month${i}`] = [];
                }
                const objObligation = Object.assign({plan_type: 1, planType: 1, leftMonth: this.defMonth}, el);
                this.combinationsArrays(objObligation, 0, true);
                // this.chgDataObl({ tableData: this.formObligation, indx: this.formObligation.length - 1, chldIndx: undefined, fieldName: `month${this.defMonth}` })
            }
        },
        async importPayments(arrData) {
            this.formPayment = []
            this.formPaymentFact = arrData.fact
            for (const el of this.formPaymentFact) {
                el.year = this.currYear;
                el.region = this.currRegion.code;
                el.utochSum = el.total;
                el.flk = {}
                el.flk.sum = [];
                for (let i=0; i < 12; i++) {
                    el.flk[`month${i}`] = [];
                }
                const objPayment = Object.assign({plan_type: 2, planType: 2, leftMonth: this.defMonth}, el);
                this.combinationsArrays(objPayment, 1, true);
                // this.chgDataPay({ tableData: this.formPayment, indx: this.formPayment.length - 1, chldIndx: undefined, fieldName: `month${this.defMonth}` })
            }
        },
        // Остатки по доходам считает бэк: при isAdjusted=true и плановые значения,
        // и значения справки приходят уже разнесёнными
        async loadIncomeData(isAdjusted) {
            const res = await fetch(
                `/api-py/get-income-data/{"region":"${this.currRegion.code}","year":${this.currYear},"spf":"${this.spfArr}","requestId":"${this.currentAlteration.id}","date":"${this.formatDate(new Date(this.currentAlteration.date))}","isAdjusted":${isAdjusted}}`
            );
            return await res.json();
        },
        // Берёт набор под текущее состояние тумблера. Копируем, т.к. combinationsArrays
        // дописывает план в строки факта - иначе исходные массивы "испортятся" при переключении
        setIncomeData() {
            const data = (this.ostIncome ? this.incomeDataOst : this.incomeData) || {};
            this.formIncomePlan = data.plan ? JSON.parse(JSON.stringify(data.plan)) : [];
            this.formIncomeFact = data.fact ? JSON.parse(JSON.stringify(data.fact)) : [];
            this.formIncomePlan.forEach((item) => {
                this.$set(item, 'sum', item.month0 + item.month1 + item.month2 + item.month3 + item.month4 +
                    item.month5 + item.month6 + item.month7 + item.month8 + item.month9 + item.month10 + item.month11);
            });
        },
        buildIncomeTree() {
            if (this.formIncomeFact !== undefined) {
                this.formIncomeFact.forEach((item) => {
                    this.combinationsArrays(item, -1, false);
                });
            }
        },
        // Тумблер переключает уже загруженные наборы, к сервису не обращаемся(вызывается при переключении)
        ostIncomeChange() {
            localStorage[this.lsOstatkiIncomeFilter] = this.ostIncome;
            try {
                this.formIncome = [];
                this.setIncomeData();
                this.buildIncomeTree();
            } catch (error) {
                this.makeToast('danger', this.setText('errors.err'), error.toString());
            }
        },
        arrChange() {
            localStorage[this.lsOstatkiFilter] = this.ost;
            this.ostChange(this.formObligation);
            this.ostChange(this.formPayment);
        },
        ostChange(arr) {
            arr.forEach((item, index) => {
                for (let i = 0; i < 12; i++) {
                    this.$set(item, 'month' + i, 0);
                }
                if (this.ost === true) {
                    for (let i = 0; i < 12; i++) {
                        this.$set(item, 'month' + i,  Math.round((item['month_' + i]) *10)/10);
                    }
                } else {
                    for (let i = 0; i < 12; i++) {
                        if (item.leftMonth < i) {
                            this.$set(item, 'month' + i, Math.round((item['month_' + i]) *10)/10);
                        } else {
                            this.$set(item, 'month' + item.leftMonth, Math.round((item['month' + item.leftMonth] + item['month_' + i]) *10)/10);
                        }
                    }
                }
                // Проекты специфики (child_list) пересчитываем по той же логике, что и саму специфику -
                // при первичной загрузке это делает traverseAndAssign рекурсивно, а переключение тумблера
                // "Остатки" раньше обновляло только строки специфик, оставляя проекты со старыми значениями
                if (Array.isArray(item.child_list) && item.child_list.length) {
                    this.ostChange(item.child_list);
                }
                arr.splice(index, 1, item);
            })
        },
        async loadDepartGU() {
            try {
                const prm = { id: this.currentAlteration.id, date: this.formatDate(new Date(this.currentAlteration.date)) };
                const response = await fetch('/api-py/get-abp-261-gu/' + JSON.stringify(prm));
                this.departGU = await response.json();
                this.nameLocale(this.departGU);
                if (this.departGU.length > 0) {
                    this.departGU.push({
                        "name_ru": "Все",
                        "name_kk": "Барлығы",
                        "name_en": "All",
                        "code": 0,
                        "childGu": []
                    });
                    this.departGU
                        .sort((a, b) => (a.code - b.code > 0 ? 1 : -1));
                    this.abp261gu = this.departGU[0];
                }
            } catch (error) {
                this.makeToast('danger', this.setText('errors.ga') + store.state.user.sub, error.toString());
            }
        },
        sortData(){
            if (this.abp261gu.code === 0) {
                this.formObligation = this.arrObligation;
                this.formPayment = this.arrPayment;
            } else {
                let listGu = ''
                listGu = this.abp261gu.childGu.join(', ');
                this.formObligation = this.arrObligation.filter((item) => listGu.includes(item.gu));
                this.formPayment = this.arrPayment.filter((item) => listGu.includes(item.gu));
            }
        },
        async downloadFile(app) {
            if (this.isLoadToJournalEnabled) {
                // Выгрузка в журнал
                const appDict = {
                    'SVI_IPF_PO': 'СВИ ИПФ(обязательства)',
                    'SVI_IPF_PP': 'СВИ ИПФ(платежи)',
                    'SVI_SPF_PO': 'СВИ СПФ(обязательства)',
                    'SVI_SPF_PP': 'СВИ СПФ(платежи)',
                    'SVI_SP_PB': 'СВИ СПП'
                }
                const item = this.currentAlteration;

                let params = {}
                if (app === 'SVI_IPF_PO') {
                    params = {
                        'type': 'OBLIGATION',
                        'requestId': item.id,
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_IPF_PP') {
                    params = {
                        'type': 'PAYMENT',
                        'requestId': item.id,
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_SPF_PO') {
                    params = {
                        'type': 'OBLIGATION',
                        'requestId': item.id,
                        'level': 'UF',
                        'dataLevel': 'PRG',
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_SPF_PP') {
                    params = {
                        'type': 'PAYMENT',
                        'requestId': item.id,
                        'level': 'UF',
                        'dataLevel': 'PRG',
                        'planType': 'EXPENSE',
                        'addIpf': false,
                        'addAllAgreed': false,
                        'isLeftMonth': true,
                        'code': app
                    }
                } else if (app === 'SVI_SP_PB') {
                    params = {
                        'requestId': item.id,
                        'addSpp': false,
                        'addAllAgreed': false,
                        'planType': 'INCOME',
                        'code': app,
                    }
                }

                let desc = ''
                if (this.tabIndex === 2 || this.tabIndex === 3) {
                    desc = item.abp
                } else if (this.tabIndex === 4 || this.tabIndex === 5) {
                    desc = item.region
                }
                const date = new Date(item.date).toLocaleDateString();
                const filename = `${appDict[app]}_${desc}_${item.number}_${date}.xls`

                const journalParams = {
                    sourceTab: this.tabCode,
                    region: item.region,
                    abp: item.abp,
                    gu: item.gu,
                    number: item.number,
                    requestType: item.requestType,
                    date: moment(item.date).format('YYYY-MM-DD'),
                    agreementStatus: item.status.status,
                    name: appDict[app],
                    parameters: params,
                    reportKey: 'BASE',
                    filename: filename,
                }
                if (this.abp261gu?.code) {
                    journalParams.gu261 = this.abp261gu.code
                }

                const initilizeResponse = await fetch('/api/alteration/journal', {
                    method: 'POST',
                    body: JSON.stringify(journalParams),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                if (!initilizeResponse.ok) {
                    this.makeToast('danger', 'Ошибка', 'Ошибка инициализации в журнал')
                    return
                }
                const entryId = await initilizeResponse.text()
                this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')

                fetch(`/api/alteration/journal/${entryId}`, {
                    method: 'POST',
                })

                this.$emit('reload-journal')
            } else { // Прямая выгрузка
                try {
                    const item = this.currentAlteration;
                    if (app === 'SVI_IPF_PO') {
                        await axios.get(`api/budget-execution-base/xls?type=OBLIGATION&requestId=${item.id}&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`,
                            {responseType: 'blob',
                                headers: {
                                    'Authorization': `Bearer ${this.$store.getters.token}`,
                                    'Content-Type': 'application/json'
                                }
                            }).then(response => {
                            this.currentRequest = response.data
                        }).catch(error => {
                            console.log(error)
                            this.currentRequest = null
                        })
                    }
                    if (app === 'SVI_IPF_PP') {
                        await axios.get(`api/budget-execution-base/xls?type=PAYMENT&requestId=${item.id}&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`,
                            {responseType: 'blob',
                                headers: {
                                    'Authorization': `Bearer ${this.$store.getters.token}`,
                                    'Content-Type': 'application/json'
                                }
                            }).then(response => {
                            this.currentRequest = response.data
                        }).catch(error => {
                            console.log(error)
                            this.currentRequest = null
                        })
                    }
                    if (app === 'SVI_SPF_PO') {
                        await axios.get(`api/budget-execution-base/xls?type=OBLIGATION&requestId=${item.id}&level=UF&dataLevel=PRG&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`,
                            {responseType: 'blob',
                                headers: {
                                    'Authorization': `Bearer ${this.$store.getters.token}`,
                                    'Content-Type': 'application/json'
                                }
                            }).then(response => {
                            this.currentRequest = response.data
                        }).catch(error => {
                            console.log(error)
                            this.currentRequest = null
                        })
                    }
                    if (app === 'SVI_SPF_PP') {
                        await axios.get(`api/budget-execution-base/xls?type=PAYMENT&requestId=${item.id}&level=UF&dataLevel=PRG&planType=EXPENSE&addIpf=false&addAllAgreed=false&isLeftMonth=true&code=${app}`,
                            {responseType: 'blob',
                                headers: {
                                    'Authorization': `Bearer ${this.$store.getters.token}`,
                                    'Content-Type': 'application/json'
                                }
                            }).then(response => {
                            this.currentRequest = response.data
                        }).catch(error => {
                            console.log(error)
                            this.currentRequest = null
                        })
                    }
                    if (app === 'SVI_SP_PB') {
                        await axios.get(`api/budget-execution-base/xls?requestId=${item.id}&addSpp=false&addAllAgreed=false&planType=INCOME&code=${app}`,
                            {responseType: 'blob',
                                headers: {
                                    'Authorization': `Bearer ${this.$store.getters.token}`,
                                    'Content-Type': 'application/json'
                                }
                            }).then(response => {
                            this.currentRequest = response.data
                        }).catch(error => {
                            console.log(error)
                            this.currentRequest = null
                        })
                    }
                    const date = new Date(item.date).toLocaleDateString();
                    const appDict = {
                        'SVI_IPF_PO': this.setText('svi_ipf_obl'),
                        'SVI_IPF_PP': this.setText('svi_ipf_pay'),
                        'SVI_SPF_PO': this.setText('svi_spf_obl'),
                        'SVI_SPF_PP': this.setText('svi_spf_pay'),
                        'SVI_SP_PB': this.setText('svi_spp')
                    }
                    let name = appDict[app]
                    let desc = ''
                    if (this.tabIndex === 2 || this.tabIndex === 3) {
                        desc = item.abp
                    } else if (this.tabIndex === 4 || this.tabIndex === 5) {
                        desc = item.region
                    }
                    name += `_${desc}_${item.number}_${date}.xls`
                    if (this.currentRequest !== null) {
                        const url = window.URL.createObjectURL(new Blob([this.currentRequest], {type: 'application/xls'}));
                        const link = document.createElement('a');
                        link.href = url;
                        link.target = '_blank';
                        link.setAttribute('download', name);
                        link.click();
                    } else {
                        this.makeToast('danger', this.setText('warning'), this.setText('flc.empty'));
                    }
                } catch (error) {
                    console.error(this.setText('errors.file'), error.toString());
                    this.toast('danger', this.i18n.translate('error.cannot_load_files'), this.setText('flc.notfound'))
                }
            }
        },
        roleIncludes(val){
            let ed = 0;
            if (this.accessLevel && this.accessLevel.operations) {
                this.accessLevel.operations.forEach((op, ind) => {
                    if (op.toLowerCase().lastIndexOf(val) !== -1) {
                        ed += 1;
                    }
                });
            }
            return ed > 0
        },
        flcCheck(arr, el){
            let ch = false;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].id === el.id) {
                    ch = true;
                }
            }
            if (!ch) {
                arr.push(el);
            }
        },
        addItemTr(el){
            // CTransfAddItemModal эмитит { parent, newChildren } - родительскую строку специфики
            // и только новые проекты, без старых child_list (см. CTransfAddItemModal.onAddItems)
            // 1. Определяем текущий тип и противоположный тип
            const parentCopy = JSON.parse(JSON.stringify(el.parent));
            const currentType = el.types; // 1 (обязательства) или 2 (платежи)
            const oppositeType = currentType === 1 ? 2 : 1;
            // 2. ДОБАВЛЯЕМ В ТЕКУЩУЮ ТАБЛИЦУ (откуда открыли модалку)
            if (currentType === 1) {
                this.updateFormData(el.parent, el.newChildren, this.formObligation, this.planOblProjectMap);
            } else if (currentType === 2) {
                this.updateFormData(el.parent, el.newChildren, this.formPayment, this.planPayProjectMap);
            }
            // 3. ПОДГОТАВЛИВАЕМ ДАННЫЕ ДЛЯ ПРОТИВОПОЛОЖНОЙ ТАБЛИЦЫ
            // Делаем копию родителя, чтобы ссылки на объекты не пересекались
            parentCopy.plan_type = oppositeType;
            // Создаем новый массив дочерних элементов с измененным plan_type
            const invertedChildren = el.newChildren.map(child => {
                return {
                    ...child,
                    plan_type: oppositeType,
                    flk: {} // Создаем новый пустой объект ФЛК, чтобы ошибки не дублировались между таблицами
                };
            });

            // 4. ДОБАВЛЯЕМ В ПРОТИВОПОЛОЖНУЮ ТАБЛИЦУ
            if (oppositeType === 1) {
                this.updateFormData(parentCopy, invertedChildren, this.formObligation, this.planOblProjectMap);
            } else if (oppositeType === 2) {
                this.updateFormData(parentCopy, invertedChildren, this.formPayment, this.planPayProjectMap);
            }
        },
        updateFormData(parent, newChildren, formArray, projectMap) {
            const parentProject = projectMap.get(parent.id);
            // if (parentProject) {
            //     const newProject = newChildren.find(child => child.id === parent.id);
            //     if (newProject) {
            //         const newProjectIndex = formArray.findIndex(item => item.id === parent.id);
            //         if (newProjectIndex !== -1) {
            //             formArray[newProjectIndex] = newProject;
            //         } else {
            //             formArray.push(newProject);
            //         }
            //     }
            // }
            const obj = this.findParentRow(parent, formArray);
            if (!obj) return;
            if (!Array.isArray(obj.child_list)) { obj.child_list = []; }
            for (const eChild of newChildren) {
                if (!this.findRowTr(eChild, obj['child_list'])) {
                    if (eChild?.new === true && eChild?.plan_type === obj.plan_type) {
                        const clonedChild = JSON.parse(JSON.stringify(eChild));
                        clonedChild.new = false;
                        // Совмещаем план нового проекта с планом по этому же проекту (если специфика детализирована в плане)
                        this.assignProjectPlan(clonedChild, projectMap);
                        obj['child_list'].push(clonedChild);
                    }
                }
            }

            for (let i = 0; i < 12; i++) {
                obj[`month${i}`] = 0;
                obj[`month_${i}`] = 0;
                let chldSum = 0;
                let chldSum_ = 0;

                if (Array.isArray(obj.child_list)) {
                    for (const child of obj['child_list']) {
                        chldSum += child[`month${i}`] || 0;
                        chldSum_ += child[`month_${i}`] || 0;
                    }
                }

                obj[`month${i}`] = chldSum;
                obj[`month_${i}`] = chldSum_;
            }

            obj['collapse'] = true;
            formArray.splice(obj.index, 1, obj);
        },
        async loadSettingsHist() {
            const response = await fetch(`/api-py/get-settings`);
            const settingsData = await response.json();
            for (const el of settingsData) {
                if (['history_transfers'].includes(el['code'].trim())) {
                    this.historyTransfersButton = el['value']
                }
            }
        },
        localeChange() {
            this.ds420_list[0].text = this.$t('modules.budget_execution_alteration.ds_420_intgration');
            this.ds420_list[1].text = this.$t('modules.budget_execution_alteration.ds_420_loader');
        },
        async loadApplicationsTitle() {
            if (!this.selectedAlteration) return;

            try {
                const date = new Date(this.currentAlteration.date).toISOString().split('T')[0];
                const response = await axios.get(`/api-py/alteration_applications-list/${date}`);
                this.appsList = response.data || [];
            } catch (error) {
                console.error('Ошибка при загрузке списка приложений', error);
                this.makeToast('danger', 'Ошибка', 'Не удалось загрузить список приложений');
            }
        },
        getErrorColor(error) {
            const colorMap = {
                1: '#ff2400', // красный
                2: '#00695C', // зеленый
                3: '#4169e1', // синий
                4: '#ffb02e',  // оранжевый
                6: '#8A2BE2'  // фиолетовый
            };
            return colorMap[error?.id] || 'red'; // значение по умолчанию
        },
        async loadDictBudgRegLvl6() {
            try {
                const response = await fetch('/api-py/get-budget-regions-level-6/');
                const regLvl6 = await response.json();
                regLvl6.forEach((row, ind) => { this.regionLvl6.push(row.code); });
            } catch (error) {
                this.makeToast('danger', this.setText('errors.err'), error.toString());
            }
        },
        appText(app) {
            switch (`${i18nService.locale}`) {
                case 'ru':
                    return `${app.name_ru} ${app.full_name_ru}`
                case 'kk':
                    return `${app.name_kz} ${app.full_name_kz}`
                case 'en':
                    return `${app.name_ru} ${app.full_name_ru}`
                default:
                    break;
            }
        }
    },
    filters: {
    }
}
</script>
<style lang="scss" scoped>
.icon-btn{
    width: 20px;
    height: 20px;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none !important;
    background-color: transparent;
    border: 1px solid rgba(28, 42, 62, 1);
    border-radius: 50%;
    margin: 0;
}
.icon-btn i{
    font-size: 0.4444444444rem;
    color: rgba(28, 42, 62, 1);
}
.duplicate-button{
    position: absolute;
    z-index: 2;
    top: 5px;
    right: 20px;
}
.flc_modal {
    width:100%;
    height:100%;
    &__body {
        background-color: #f7f9fc;
        border: 1px solid #d3dbe3;
        border-radius: 5px;
        margin-bottom: 23px;
    }

    &__title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 26px;
    }

    &__item {
        display: flex;
        align-items: center;
        height: 50px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0px 10px 0px 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .input-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
        &-label {
            width: 400px;
            font-weight: 600;
            font-size: 14px;
            color: #6087a0;
            cursor: pointer;
            display: flex;
            justify-self: flex-start;
        }
    }
    .form-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
    }
}
</style>
